<template v-slot:activator="{ on }">
  <v-content class="bg-content-4">
      <v-container grid-list-xl fluid style="padding: 35px; margin-top: -40px;" class="card-animate-2">
        <v-card dark class="theme-bg-card-2 card-animate-2">
          <v-app-bar
              color="rgba(12, 22, 27, 0.9)"
              max-height="75"
              height="75"
              elevation="3"
              dense
              dark
            >
            <v-toolbar-title color="info">
              <v-avatar size="40">
                <img src="@/assets/InvoiceIconNEW3.png" />
              </v-avatar>
              Proposals
            </v-toolbar-title>

            <v-spacer></v-spacer>
<!-- 
            <div class="mr-1 text-center">
            <v-btn class="button2 mr-1" @click="nextSort"><v-btn icon><v-icon>mdi-arrow-left-right-bold</v-icon></v-btn></v-btn>
            </div>
            <div class="mr-1 text-center">
            <v-btn class="button2 mr-1" @click="toggleOrder"><v-btn icon><v-icon>mdi-arrow-up-down-bold</v-icon></v-btn></v-btn>
            </div> -->
            <div>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
                dense
                outlined
                class="mr-1"
                v-on:change="searchProposal"
              ></v-text-field>

            </div>
            <v-btn
              class="ma-1 btn-text"
              elevation="2"
              outlined
              depressed
              color="secondary"
              @click="openForm"
            >
              <p class="btn-text">Create</p>
            </v-btn>
          </v-app-bar>

          <v-data-table
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            class="theme-bg-card-2"
            :loading="tableLoader"
            loading-text="Loading... Please wait"
            :headers="headers"
            :items="proposalsList"
            :search="search"
            max-width="750"
            id="virtual-scroll-table"
            v-scroll:#virtual-scroll-table-2="onScroll"
          >
            <template v-slot:item.controls="props">
              <i
                class="fa fa-trash thrash"
                @click="deleteConfirmation(props.item)"
              ></i>
              <i
                class="fa fa-pencil thrash"
                @click="editProposal(props.item)"
                style="margin-left: 20px"
              ></i>
            </template>
          </v-data-table>
        </v-card>
      </v-container>

      <v-container class="card-animate-2" style="width: auto; top: 180px; padding-left: 0px; padding-right: 50px; padding-top: 150px; padding-bottom: 50px; margin-left: 80px; margin-bottom: 150px;  margin-top: 250px;">         
        <h3>Proposal Reports</h3>

        <v-divider></v-divider>
 
  <v-row>
    
  <v-menu
    v-model="menuStartDate"
    :close-on-content-click="false"
    :nudge-right="20"
    :nudge-top="-20"
    transition="scale-transition"
    offset-y
    min-width="130px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        v-model="startDate"
        label="Start date"
        append-icon="mdi-calendar"
        v-on="on"
        cursor="pointer"
      ></v-text-field>
    </template>
    <v-date-picker v-model="startDate" @input="menuStartDate = false"></v-date-picker>
  </v-menu>

  <v-menu
    v-model="menuEndDate"
    :close-on-content-click="false"
    :nudge-right="20"
    :nudge-top="-20"
    transition="scale-transition"
    offset-y
    min-width="130px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        v-model="endDate"
        label="End date"
        append-icon="mdi-calendar"
        v-on="on"
        cursor="pointer"
      ></v-text-field>
    </template>
    <v-date-picker v-model="endDate" @input="menuEndDate = false"></v-date-picker>
  </v-menu>

  <v-menu       
    transition="scale-transition"
    offset-y
    min-width="130px"
  >
  <template v-slot:activator="{ on: menuOn }">
    <v-text-field
      v-model="reportType"
      label="Report Type"
      append-icon="mdi-chevron-down"
      v-on="{ ...on, ...menuOn }"
    ></v-text-field>
  </template>
  <v-list>
    <v-list-item
      v-for="(item, index) in ['Proposal Report', 'Profit Margins Report', 'Proposal Owner Report']"
      :key="index"
      @click="reportType = item"
    >
      <v-list-item-title>{{ item }}</v-list-item-title>
    </v-list-item>
  </v-list>
</v-menu>

  <!-- <button @click="generateReport">Generate Report</button> -->

  <v-btn class="button ma-2" color="primary" @click="generateReport">Report</v-btn>
  <transition name="slide-fade">
    <v-btn v-if="reportGenerated" class="button ma-2" color="primary" @click="downloadReport">
      Download Report
    </v-btn>
  </transition>

      <!-- <v-btn class="ma-3" color="primary" @click="generateReport">Generate Report</v-btn>
      <v-btn
      class="ma-3"
      color="primary"
      @click="downloadReport"
    >
      Download Report
    </v-btn> -->
    <!-- <v-col>
      <v-select
    v-model="selectedFields"
    :items="availableFields"
    label="Fields to include"
    multiple
    chips
  ></v-select>
    </v-col>
    <v-col>
      <v-select
        v-model="activeFilters"
        :items="generatedFilters"
        label="Active Filters"
        multiple
      ></v-select>
    </v-col>
    <v-col>
    <v-checkbox
      v-model="selectAll"
      label="Select All"
      @change="selectAllInvoices"
    ></v-checkbox>
  </v-col> -->
<!-- <v-col>
<v-btn
  class="ma-3"
  color="primary"
  @click="generateReport"
>
  Generate Report
</v-btn>
</v-col> -->
  </v-row>

</v-container>
<v-flex sm4 xs4 md4 lg12>
 
<!-- <iframe ref="outputIframe"
  src="https://play.viostream.com/iframe/s0m3m3d14?playerKey=s0m3p14y3r"
  frameborder="0" allowfullscreen="" style="position:relative; top:0; left: 0">
</iframe> -->

<iframe ref="outputIframe" frameborder="0" class="data-table-iframe" style="margin-left: 100px; margin-top: 200px; width: 88%; height: 500px; padding-block: 20px;"></iframe>


  <!-- <iframe ref="outputIframe" frameborder="0" class="default-size" style="margin-left: 90px; margin-bottom: 50px; width: 90%; height: 500px;"></iframe> -->
    </v-flex>
  <v-flex sm4 xs4 md4 lg12>

<bar-chart style="margin-left: 100px; margin-top: 50px; margin-bottom: 150px; width: 87%; padding-block: 20px;" ref="salesChart" v-if="reportType === 'Proposal Report'"></bar-chart>
<bar-chart style="margin-left: 100px; margin-top: 50px; margin-bottom: 150px; width: 87%; padding-block: 20px;" ref="profitMarginsChart" v-if="reportType === 'Profit Margins Report'"></bar-chart>
<bar-chart style="margin-left: 100px; margin-top: 50px; margin-bottom: 150px; width: 87%; padding-block: 20px;" ref="proposalOwnerChart" v-if="reportType === 'Proposal Owner Report'"></bar-chart>

</v-flex>
    <v-dialog v-model="showConfirmation" max-width="550">
      <v-card class="theme-bg-card-6">
        <v-card-title class="text-h5">
          Are you sure you want to delete this proposal?
        </v-card-title>

        <v-card-text :v-if="itemToBeDeleted._id">
          Proposal: {{ itemToBeDeleted.accountName }}
          {{ itemToBeDeleted.accountType }}
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="green darken-1"
            text
            @click="showConfirmation = false"
          >
            Disagree
          </v-btn>
          <v-form>
            <v-btn
              color="green darken-1"
              text
              :loading="loading3"
              :disabled="loading3"
              @click="deleteProposal()"
              v-on:keyup.32="deleteProposal()"
            >
              Agree
            </v-btn>
          </v-form>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <v-dialog v-model="showEmailConfirmation" max-width="500" max-height="100">
      <v-card class="theme-bg-card-6">
            <v-toolbar-title style="padding: 16px;">
              <v-avatar size="60">
                <img src="@/assets/EmailIcon.png" />
              </v-avatar>
            </v-toolbar-title>
            
        <v-spacer></v-spacer><v-spacer></v-spacer>
  <h1 class="user-speach">
    <v-flex class="space" />   
    <h1 class="typing2">
      <span>{{ speak }}</span>
    </h1>
  </h1>

      </v-card>
    </v-dialog>


    <v-overlay :value="overlay" opacity="0.98" z-index="9" @click.self="overlay = false">
      <v-card
        v-scroll.self="onScroll"
        style="background: #485156;"
        class="overflow-y-auto popup-container theme-bg-card-proposal"
      >
        <v-layout row wrap fluid>
          <v-flex xs12 sm12 md12>
            <v-list-item class="mb-margin">
              <v-list-item-content>
                <v-form
                  ref="invoiceform"
                  lazy-validation
                  aria-autocomplete="off"
                >
                  <v-banner
                    class="justify-center text-h5 font-weight-light"
                    sticky
                  >
                    <v-avatar size="70">
                      <img src="@/assets/InvoiceIconNEW3.png" />
                    </v-avatar>
                    Proposal Generator
                  </v-banner>

                  <h4 class="display-6 font-weight-thin">
                    General Information
                  </h4>

                  <div
                    style="margin-bottom:20px;display:flex;flex-direction:row"
                  >
                  <v-row>
                      <v-select
                        v-model="formFields.proposalOwner"
                        class="mg-lr14"
                        :items="ownerOptions"
                        hint="Sadik Nomair"
                        label="Proposal Owner"
                        outlined
                      ></v-select>

                      <input
                        type="date"
                        v-model="formFields.proposalDate"
                        class="date-picker"
                      />
                      <v-select
                      v-model="formFields.proposalStatus"
                      class="mg-lr14"
                      :items="proposalStatus"
                      label="Proposal Status"
                      outlined
                    ></v-select>
                      <v-select
                        v-model="formFields.accountType"
                        class="mg-lr14"
                        :items="accountType"
                        hint="'Business', 'Personal', 'Non-Profit'"
                        label="Account Type"
                        outlined
                      ></v-select>
                    </v-row>
                  </div>

                  <v-row>
                    <v-autocomplete
                      v-model="selectedAccountDetails"
                      :items="account_list"
                      return-object
                      :search-input.sync="searchAccountName"
                      class="mg-lr14"
                      item-text="accountName"
                      label="Select Account Name"
                      solo
                    >
                      <template v-slot:item="{ item }">
                        <v-list-item-title
                          v-text="item.accountName"
                        ></v-list-item-title>
                      </template>
                    </v-autocomplete>
                    <v-btn
                      color="accent"
                      class="mg-lr14"
                      outlined
                      large
                      @click.stop="showAccountForm = true"
                    >
                      Add Account</v-btn
                    >
                    <AccountForm
                      :visible="showAccountForm"
                      @close="showAccountForm = false"
                    />

                  </v-row>

                  <v-row>
                    <v-autocomplete
                      v-model="selectedContactDetails"
                      :items="contact_list"
                      return-object
                      :search-input.sync="searchContactName"
                      class="mg-lr14"
                      item-text="contactName"
                      label="Select Contact Name"
                      solo
                    >
                      <template v-slot:item="{ item }">
                        <v-list-item-title
                          v-text="item.contactName"
                        ></v-list-item-title>
                      </template>
                    </v-autocomplete>
                    <v-btn
                      color="accent"
                      class="mg-lr14"
                      outlined
                      large
                      @click.stop="showContactForm = true"
                    >
                      Add Contact</v-btn
                    >
                    <ContactForm
                      :visible="showContactForm"
                      @close="showContactForm = false"
                    />

                  </v-row>

                  <h4 class="display-6 font-weight-thin">Address</h4>

                  <v-row>
                    <v-text-field
                      v-model="formFields.street"
                      class="mg-lr14 "
                      label="Street"
                      outlined
                      required
                    ></v-text-field>
                    <v-text-field
                      v-model="formFields.city"
                      class="mg-lr14 "
                      label="City"
                      outlined
                      required
                    ></v-text-field>
                  </v-row>

                  <v-row>
                    <v-text-field
                      class="mg-lr14 "
                      v-model="formFields.state"
                      label="State"
                      outlined
                      required
                    ></v-text-field>
                    <v-text-field
                      class=""
                      v-model="formFields.zipcode"
                      label="Zip Code"
                      outlined
                      required
                      style="color: #bbd54d;"
                    ></v-text-field>
                  </v-row>
                  <h4 class="display-6 font-weight-thin">
                    Proposal Details
                  </h4>

                  <div>
                    <div
                        v-for="(input, k) in inputs"
                        :key="k"
                        style="width: 70%; margin-left: 0px; padding: 10px; margin-bottom: 25px; border-radius: 10px; border: 1px solid rgba(120,181,156,.2);"
                      >
                        <input
                          type="text"
                          placeholder="Service"
                          class="form-control-2"
                          v-model="input.Model"
                          style="padding: 20px; margin-left: 0px; width: 100%;"
                          @change="searchProducts($event, k, 'product')"
                        />
                        <div
                          class="loader"
                          v-if="
                            productLoader &&
                              optionIndex == k &&
                              type == 'product'
                          "
                        ></div>
                        <div
                          v-if="
                            productsList.length &&
                              optionIndex == k &&
                              type == 'product'
                          "
                        >
                          <ul class="product-list">
                            <li
                              v-for="(product, i) in productsList"
                              :key="i"
                              class="item"
                              @click="selectProduct(product, k)"
                            >
                              {{ product.Make }}-{{ product.Model }}-{{
                                product.Memory
                              }}
                            </li>
                          </ul>
                        </div>
                        <input
                          type="text"
                          placeholder="Personnel"
                          class="form-control-2"
                          v-model="input.quantity"
                          style="margin-left: 0px; width: 25%;"
                          @change="handleTotal"
                        />
                        <input
                          type="text"
                          placeholder="Proposed Hourly"
                          class="form-control-2"
                          v-model="input.price"
                          style="margin-left: 0px; width: 25%;"
                          @change="handleTotal"
                        />
                        <input
                          type="text"
                          placeholder="Hourly Rate"
                          class="form-control-2"
                          v-model="input.amount"
                          style="margin-left: 0px; width: 25%;"
                          @change="handleTotal"
                        />
                        <input
                          type="text"
                          placeholder="Holiday Rate"
                          class="form-control-2"
                          v-model="input.holidayRate"
                          style="margin-left: 0px; width: 25%;"
                          @change="handleTotal"
                        />
                        <input
                          type="text"
                          placeholder="Golf Cart Rate"
                          class="form-control-2"
                          v-model="input.golfCartRate"
                          style="margin-left: 0px; width: 25%;"
                          @change="handleTotal"
                        />
                        <input
                          type="text"
                          placeholder="Days per Week"
                          class="form-control-2"
                          v-model="input.daysFromWeek"
                          style="margin-left: 0px; width: 25%;"
                          @change="handleTotal"
                        />
                        <input
                          type="text"
                          placeholder="Hours per Day"
                          class="form-control-2"
                          v-model="input.serviceHours"
                          style="margin-left: 0px; width: 25%;"
                          @change="handleTotal"
                        />

                      <span style="margin-left: 10px" class="d-flex-row">
                        <i
                          class="fa fa-trash action-btn"
                          @click="remove(k)"
                          v-show="k || (!k && inputs.length > 1)"
                        ></i>
                        <i
                          style="margin-left: 10px"
                          class="fa fa-plus-circle action-btn"
                          @click="add(k)"
                          v-show="k == inputs.length - 1"
                        ></i>
                      </span>
                    </div>
                    <v-row style="padding-block: 30px; margin-left: -15px; margin-right: 5px;">
                      <v-text-field class="form-control-2" style="margin-left: 20px; padding-top: 40px; width: 15%;" label="Total Days per Month" v-model="formFields.totalDaysPerMonth" readonly></v-text-field>
                      <v-text-field class="form-control-2" style="margin-left: 20px; padding-top: 40px; width: 15%;" label="Total Hours per Month" v-model="formFields.totalHoursPerMonth" readonly></v-text-field>
                      <v-text-field class="form-control-2" style="margin-left: 20px; padding-top: 40px; width: 15%;" label="Daily Cost" v-model="formattedDailyCost" readonly></v-text-field>
                      <v-text-field class="form-control-2" style="margin-left: 20px; padding-top: 40px; width: 15%;" label="Weekly Cost" v-model="formattedWeeklyCost" readonly></v-text-field>
                      <v-text-field class="form-control-2" style="margin-left: 20px; padding-top: 40px; width: 15%;" label="Monthly Cost" v-model="formattedMonthlyCost" readonly></v-text-field>
                      <v-text-field class="form-control-2" style="margin-left: 20px; padding-top: 40px; width: 15%;" label="Yearly Cost" v-model="formattedYearlyCost" readonly></v-text-field>
                      <v-text-field class="form-control-2" style="margin-left: 20px; padding-top: 40px; width: 15%;" label="Holiday Rate" v-model="formattedHolidayRate" readonly></v-text-field>

                      <v-text-field class="form-control-2" style="margin-left: 20px; padding-top: 40px; width: 15%;" label="Days from Week" v-model="formFields.daysFromWeek" readonly></v-text-field>
                      <v-text-field class="form-control-2" style="margin-left: 20px; padding-top: 40px; width: 15%;" label="Service Hours" v-model="formFields.serviceHours" readonly></v-text-field>
  <v-text-field class="form-control-2" style="margin-left: 20px; padding-top: 40px; width: 15%;" label="Golf Cart Rate" v-model="formFields.golfCartRate" readonly></v-text-field>
  <v-text-field 
  class="form-control-2" 
  style="margin-left: 20px; padding-top: 40px; width: 15%;" 
  label="Total Hourly Rate" 
  v-model="formattedHourlyCost" 
  readonly>
</v-text-field>

  
  
  <!-- <v-btn color="primary" @click="exportToPdf">Export to PDF</v-btn> -->
                      </v-row>
                    <div class="d-flex-col" style="align-items: end">
                      <input
  type="text"
  placeholder="Daily Cost"
  class="form-control calc"
  :value="formatCurrency(formFields.dailyCost)"
  @change="handleInputChange('dailyCost', $event)"
/>
<input
  type="text"
  placeholder="Weekly Cost"
  class="form-control calc"
  :value="formatCurrency(formFields.subtotal)"
  @change="handleInputChange('subtotal', $event)"
/>
<input
  type="text"
  placeholder="Monthly Cost"
  class="form-control calc"
  :value="formatCurrency(formFields.monthlyCost)"
  @change="handleInputChange('monthlyCost', $event)"
/>
<input
  type="text"
  placeholder="Yearly Cost"
  class="form-control calc"
  :value="formatCurrency(formFields.yearlyCost)"
  @change="handleInputChange('yearlyCost', $event)"
/>

                    </div>
                  </div>
                  <div id="invoice-preview" class="invpreview" style="padding-block: 20px; background: #fff; color: #333;">
  <!-- Company Logo and Information -->
  <div style="display: flex; justify-content: space-between; align-items: start; margin-bottom: -100px; padding-top: 40px;">
    <!-- Company Logo on the Left -->
    <div v-if="currentPage === 1" class="page">
      <img :src="images.cover" class="cover" alt="Cover">
    </div>
    <div v-if="currentPage === 2" class="page">
      <div class="header">
  <p class="text">WELCOME TO INSTAGUARD SECURITY SERVICES</p>
</div>
<br />
<div class="row-container">
    <div class="left-column">
      <span class="account-name">{{ formFields.accountName }}</span>
    </div>
    <div class="right-column">
      <span class="proposal-date">{{ formattedProposalDate }}</span>
    </div>
  </div>
<p style="margin-top:0pt;margin-bottom:0pt;margin-left:0in;text-align:left;"><span style="font-size:18px;font-family: Lato, sans-serif;color:black;">{{ formFields.contactName }}</span></p>
<p style="margin-top:0pt;margin-bottom:0pt;margin-left:0in;text-align:left;"><span style="font-size:18px;font-family: Lato, sans-serif;color:black;">{{ formFields.street }}</span></p>
<p style="margin-top:0pt;margin-bottom:0pt;margin-left:0in;text-align:left;"><span style="font-size:18px;font-family: Lato, sans-serif;color:black;">{{ formFields.city }}, {{ formFields.state }} {{ formFields.zipcode }}</span></p>
<br />
<p style="margin-top:0pt; margin-bottom:0pt; margin-left:0in; text-align:left;">
    <span style="font-size:18px; font-family: Lato, sans-serif; color:black; font-weight:bold;">
      {{ firstName }},
    </span>
  </p>
<!-- <p style="margin-top:0pt;margin-bottom:0pt;margin-left:0in;text-align:left;"><span style="font-size:18px;font-family: Lato, sans-serif;color:black;font-weight:bold;"><span style="font-size:18px;font-family: Lato, sans-serif;color:black;font-weight:bold;">{{ formFields.contactName }}</span>,</span></p> -->
<br />
<p style="margin-top:0pt;margin-bottom:0pt;margin-left:0in;text-align:left;"><span style="font-size:18px;font-family: Lato, sans-serif;color:black;">We appreciate this opportunity to introduce our services in detail. Please review the following proposal we are submitting for the security protection services needed at&nbsp;</span><span style="font-size:18px;font-family: Lato, sans-serif;color:black;font-weight:bold;"> {{ formFields.accountName }}</span><span style="font-size:18px;font-family: Lato, sans-serif;color:black;">.&nbsp;</span></p>
<br>
<p style="margin-top:0pt;margin-bottom:0pt;margin-left:0in;text-align:left;"><span style="font-size:18px;font-family: Lato, sans-serif;color:black;">Our reputation rests on the quality of the security services &amp; &nbsp;support we provide to our clients. We have grown into an industry leader &amp; succeeded by simply exceeding our customers&rsquo; expectations.&nbsp;</span></p>
<br>
<p style="margin-top:0pt;margin-bottom:0pt;margin-left:0in;text-align:left;"><span style="font-size:18px;font-family: Lato, sans-serif;color:black;">Instaguard</span><span style="font-size:18px;font-family: Lato, sans-serif;color:black;">&nbsp;works hard to provide the best security services in California. We treat all our clients and guards with respect, so there is a very good chance that our clients will to us for future security service needs.&nbsp;</span></p>
<br>
<p style="margin-top:0pt;margin-bottom:0pt;margin-left:0in;text-align:left;"><span style="font-size:18px;font-family: Lato, sans-serif;color:black;">Instaguard</span><span style="font-size:18px;font-family: Lato, sans-serif;color:black;">&nbsp;has been providing security protection since 2008. As a Southern California leader in security, we proudly serve all of California. Our corporate office in in Sherman Oaks, CA we a centrally located to support Los Angeles, Ventura Counties &amp; Orange Counties.</span></p>
<br>
<p style="margin-top:0pt;margin-bottom:0pt;margin-left:0in;text-align:left;"><span style="font-size:18px;font-family: Lato, sans-serif;color:#black;">We thank you for this opportunity to introduce our company and we look forward to earning your business. Any questions, please let our team know so we can be of help.</span></p>
<br>
<p style="margin-top:0pt;margin-bottom:0pt;margin-left:0in;text-align:left;"><span style="font-size:18px;font-family: Lato, sans-serif;sans-serif;color:#262626;">Thank you,</span></p>
<p style="margin-top:0pt;margin-bottom:0pt;margin-left:0in;text-align:left;"><span style='font-size:18px;font-family: Lato, sans-serif;color:#262626; font-weight: bold;'><strong>Instaguard Team </strong></span></p>
<br />
<br />
<br />
<br />
<br />
<br />
<br />
<br />
<br />
<div>
          <img :src="images.footerwelcome" class="headercover" alt="Footer Welcome">
  </div>

</div>
    <div v-if="currentPage === 3" class="page">
      <div class="header">
        <p class="text">SCOPE OF SERVICES</p>
      </div>
      <products>
  <!-- <div class="vertWrapper">
  <div class="wrapper clearfix center">
    <div class="box"><div class="column inlineExample artooIndividual" style="text-align: center;">SECURITY OFFICERS <br> <div style="text-align: center;" class="text4"> {{ formFields.quantity }}</div></div></div>
    <div class="box"><div class="column inlineExample artooIndividual" style="text-align: center;">SERVICE DAYS <br> <div style="text-align: center;" class="text4"> {{ formFields.daysFromWeek }}</div></div></div>
    <div class="box"><div class="column inlineExample artooIndividual" style="text-align: center;">SERVICE HOURS <br> <div style="text-align: center;" class="text4"> {{ formFields.serviceHours }}</div></div></div>
  </div>
</div> -->
<v-layout row>
      <!-- Column 1 -->
      <v-flex xs4>
        <div class="vertWrapper">
      <div class="wrapper clearfix center">
        <table class="box4">
    <thead>
      <tr>
        <th class="text3">SECURITY OFFICERS</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td class="text2">{{ formFields.quantity }} </td>
      </tr>
    </tbody>
  </table>
        </div>
</div>
      </v-flex>
      
      <!-- Column 2 -->
      <v-flex xs4>
        <div class="vertWrapper">
      <div class="wrapper clearfix center">
        <table class="box4">
    <thead>
      <tr>
        <th class="text3">SERVICE DAYS</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td class="text2">{{ formFields.daysFromWeek }} </td>
      </tr>
    </tbody>
  </table>
        </div>
</div>
      </v-flex>

      <!-- Column 3 -->
      <v-flex xs4>
        <div class="vertWrapper">
      <div class="wrapper clearfix center">
        <table class="box4">
    <thead>
      <tr>
        <th class="text3">SERVICE HOURS</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td class="text2">{{ formFields.serviceHours }} </td>
      </tr>
    </tbody>
  </table>
        </div>
</div>
      </v-flex>
    </v-layout>

<div class="vertWrapper">
      <div class="wrapper clearfix center">
        <table class="box2">
    <thead>
      <tr>
        <th class="text3">SERVICE LOCATION</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td class="text2">{{ formFields.street }} {{ formFields.city }}, {{ formFields.state }} {{ formFields.zipcode }} </td>
      </tr>
    </tbody>
  </table>
        </div>
</div>



<br>
<p style="padding-left:35px;padding-right:35px;margin-top:0pt;margin-bottom:0pt;margin-left:0in;text-align:left;"><span style="font-size:18px;font-family:Lato, sans-serif;color:black;font-weight:bold;">Instaguard</span><span style="font-size:18px;font-family:Lato, sans-serif;color:black;font-weight:bold;">&nbsp;is to provide a uniformed, on-site, unarmed security officer(s) to patrol {{ formFields.accountName }}.</span></p>
<br>
<div style="padding-left:35px;padding-right:35px;padding-bottom:15px;margin-top:0pt;margin-bottom:0pt;margin-left:.0in;text-indent:-.19in;text-align:left;"><span style="font-size:18px;"><span style="font-family:Lato, sans-serif;">&bull;</span></span><span style="font-size:18px;font-family:Lato, sans-serif;color:black;"> A comprehensive set of Post Orders will be generated by the Instaguard staff to be approved by <span style="font-size:17px;font-family: Lato, sans-serif;color:black;font-weight:bold;">{{ formFields.accountName }}</span></span></div>
<div style="padding-left:35px;padding-right:35px;padding-bottom:15px;margin-top:0pt;margin-bottom:0pt;margin-left:.0in;text-indent:-.19in;text-align:left;"><span style="font-size:18px;"><span style="font-family:Lato, sans-serif;">&bull;</span></span><span style="font-size:18px;font-family:Lato, sans-serif;color:black;"> Any keys, pass codes, emergency contacts, etc. needed to perform the security functions will be provided by <span style="font-size:17px;font-family: Lato, sans-serif;color:black;font-weight:bold;">{{ formFields.accountName }}</span> into the post orders.</span></div>
<div style="padding-left:35px;padding-right:35px;padding-bottom:15px;margin-top:0pt;margin-bottom:0pt;margin-left:.0in;text-indent:-.19in;text-align:left;"><span style="font-size:18px;"><span style="font-family:Lato, sans-serif;">&bull;</span></span><span style="font-size:18px;font-family:Lato, sans-serif;color:black;"><span style="font-size:17px;font-family: Lato, sans-serif;color:black;font-weight:bold;"> {{ formFields.accountName }}</span> will provide restroom facilities for the security officer and a place for the security officer to take his/her California mandated rest breaks. Please note, the security officer by law are required two (10) minute paid rest breaks. In addition, they will be afforded a thirty (30) minute paid on-duty meal break.</span></div>
<div style="padding-left:35px;padding-right:35px;padding-bottom:15px;margin-top:0pt;margin-bottom:0pt;margin-left:.0in;text-indent:-.19in;text-align:left;"><span style="font-size:18px;"><span style="font-family:Lato, sans-serif;">&bull;</span></span><span style="font-size:18px;font-family:Lato, sans-serif;color:black;"> Assigned security consultant will address&nbsp;</span><span style="font-size:18px;font-family:Lato, sans-serif;color:black;">any and all</span><span style="font-size:18px;font-family:Lato, sans-serif;color:black;">&nbsp;future changes and concerns, information will be provided after commencement of services.</span></div>
<div style="padding-left:35px;padding-right:35px;padding-bottom:15px;margin-top:0pt;margin-bottom:0pt;margin-left:.0in;text-indent:-.19in;text-align:left;"><span style="font-size:18px;"><span style="font-family:Lato, sans-serif;">&bull;</span></span><span style="font-size:18px;font-family:Lato, sans-serif;color:black;"> Instaguard</span><span style="font-size:18px;font-family:Lato, sans-serif;color:black;">&nbsp;will provide <span style="font-size:17px;font-family: Lato, sans-serif;color:black;font-weight:bold;">{{ formFields.accountName }}</span> an introduction letter for its employees outlining our 24-hour dispatch numbers, on-site security officers, Regional Supervisor and all customer services access numbers.</span></div>
<div style="padding-left:35px;padding-right:35px;padding-bottom:15px;margin-top:0pt;margin-bottom:0pt;margin-left:.0in;text-indent:-.19in;text-align:left;"><span style="font-size:18px;"><span style="font-family:Lato, sans-serif;">&bull;</span></span><span style="font-size:18px;font-family:Lato, sans-serif;color:black;"> Instaguard</span><span style="font-size:18px;font-family:Lato, sans-serif;color:black;">&nbsp;Services includes but are not limited to: Vehicle Patrol, Security Training Facilities, Security Alarm Response, Power to Arrest, Incident Reporting, Special Event Services, Electronic Security Solution, Security Assessments, and Active Shooting, Fire/Life Safety.&nbsp;</span><span style="font-size:18px;font-family:Lato, sans-serif;color:black;">Instaguard</span><span style="font-size:18px;font-family:Lato, sans-serif;color:black;">&nbsp;mandates all security personnel undergo intensive training in: Ethics, Sexual Harassment,&nbsp;</span><span style="font-size:18px;font-family:Lato, sans-serif;color:black;">Instaguard</span><span style="font-size:18px;font-family:Lato, sans-serif;color:black;">&nbsp;Aid, CPR, Risk Assessment, Predictive Profiling, De-Escalation prevention, and Interpersonal Skills.</span></div>
<div style="padding-left:35px;padding-right:35px;margin-top:0pt;margin-bottom:0pt;margin-left:.0in;text-indent:-.19in;text-align:left;"><span style="font-size:18px;"><span style="font-family:Lato, sans-serif;">&bull;</span></span><span style="font-size:18px;font-family:Lato, sans-serif;color:black;"> Security Support shall commence on <span style="font-size:18px;font-family: Lato, sans-serif;color:black;font-weight:bold;">TBD</span> and shall continue until terminated upon 30&nbsp; days prior to written notice by either party.</span></div>
    <br />
    <br />

<div class="footer-container">
        <img :src="images.footer" class="footercover" alt="Footer">
</div>
</products>
    </div>

    <div v-if="currentPage === 4" class="page">
      <div class="header">
        <p class="text">SERVICE INVESTMENT</p>
      </div>
      <div class="vertWrapper">
      <div class="wrapper clearfix center">
        <div class="box">
  <div class="title-column">TYPE OF SECURITY SERVICE</div>
  <div class="vertical-line-container">
    <div class="vertical-line"></div>
  </div>
  <div class="content-column">
    <div v-for="(input, k) in inputs" :key="k">
      <div v-if="selectedProductInfo && optionIndex === k">
        <ul>
          <p class="text5">{{ input.Model }}</p>
        </ul>
      </div>
    </div>
  </div>
</div>



<br>
  <table class="blueTable" style="width: 665px; margin-left: 18px; margin-top: -20px;">
  <tr>
    <td>Hourly Rate</td>
    <td>{{ formattedHourlyCost }}</td>
  </tr>
  <tr>
    <td>Signage around Property</td>
    <td>Included</td>
  </tr>
  <tr>
    <td>Body Cam</td>
    <td>Included</td>
  </tr>
  <tr>
    <td>Cell Phone</td>
    <td>Included</td>
  </tr>
  <tr>
    <td>Reporting System</td>
    <td>Included</td>
  </tr>
</table>
<table style="font-family: Lato, sans-serif; width: 665px; margin-left: 18px;" class="box3">
        <thead>
          <tr>
            <th></th>
          </tr>
        </thead>
      </table>
<br />
<br />
<p style="padding-left:35px;padding-right:35px;margin-top:0pt;margin-bottom:0pt;margin-left:0in;text-align:left;"><span style="font-size:16px;font-family: Lato, sans-serif;color:black;">Note: Overtime rates will apply to work in excess of 8-hours per day or 40-hours per week. Holidays rates only apply to work on New Year’s Day, Memorial Day, Independence Day, Labor Day, Thanksgiving and Christmas. Coverage for labor disputes or natural disaster is not included except as described in the Service Rates Classification.</span></p>
<br />
<table style="font-family: Lato, sans-serif; width: 665px; margin-left: 18px;" class="box3">
        <thead>
          <tr>
            <th></th>
          </tr>
        </thead>
      </table>
<br />
<p style="padding-left:25px;padding-right:25px;margin-top:0pt;margin-bottom:0pt;margin-left:0in;text-align:left;"><span style="font-size:16px;font-family: Lato, sans-serif;color:black;"></span><span style="font-size:16px;font-family: Lato, sans-serif;color:black;">Instaguard looks forward to offering our services to your company. Please let me know the start date for services and I’ll forward our agreement for your approval.</span></p>
<br />
<p style="padding-left:25px;padding-right:25px;margin-top:0pt;margin-bottom:0pt;margin-left:0in;text-align:left;"><span style="font-size:16px;font-family: Lato, sans-serif;color:black;">Regards,</span></p>
<br />
<p style="padding-left:25px;padding-right:25px;margin-top:0pt;margin-bottom:0pt;margin-left:0in;text-align:left;"><span style='font-size:16px;font-family: Lato, sans-serif;color:black;'></span><span style='font-size:16px;font-family: Lato, sans-serif;color:black;'>&nbsp;<strong>Instaguard Team </strong></span></p>
<br />
<br />
<br />
<br />
<table style="margin-left:15px;padding-left:15px;padding-right:25px;font-size:16px; color:black; font-family: Lato, sans-serif; text-align: left;width: 700px">
  <tr>
    <th>Authorized Representative | _____________________________________</th>
  </tr>
  <br />
  <tr>
    <th>Signature | _____________________________________________________</th>
  </tr>
  <br />
  <tr>
    <th>Title | _________________________________________________________</th>
  </tr>
  <br />
  <tr>
    <th>Date | __________________________________________________________</th>
  </tr>
</table>
<br />
<br />
    <br />
    <br />
    <br />
    <br />
<div class="footer-container">
        <img :src="images.footer" class="footercover" alt="Footer">
</div>
</div>
    </div>

    </div>
    <div v-if="currentPage === 5" class="page">
      <div class="header">
    <p class="text">SERVICE COST BREAKDOWN</p>
  </div>
  <div class="vertWrapper">
    <div class="wrapper clearfix center">

      <table style="font-family: Lato, sans-serif; width: 690px; margin-left: 0px; text-align: center;" class="box">
        <thead>
          <tr>
            <th style="text-align: center;">SECURITY SERVICE PROPOSAL</th>
          </tr>
        </thead>
      </table>
      
      <table class="blueTable" style="font-family: Lato, sans-serif; font-weight: light; width: 680px">
        <tr>
          <th>Date</th>
          <th>{{ formattedProposalDate }}</th>
        </tr>
        <tr>
          <th>Standing Guard Rate</th>
          <th>{{ formattedHourlyCost }}</th>
        </tr>
        <tr>
          <th>Security Personnel</th>
          <th>{{ formFields.quantity }}</th>
        </tr>
        <tr>
          <th>Hours of Service</th>
          <th>{{ formFields.serviceHours }}</th>
        </tr>
        <tr>
          <th>Days</th>
          <th>{{ formFields.daysFromWeek }}</th>
        </tr>
      </table>
      
      <table style="font-family: Lato, sans-serif; width: 680px; margin-left: 0px;" class="box3">
        <thead>
          <tr>
            <th></th>
          </tr>
        </thead>
      </table>
      
      
      <table class="blueTable" style="font-family: Lato, sans-serif; width: 680px; margin-left: 0px; margin-top: 50px;">
        <tr>
          <th>Total Days Per Month</th>
          <th>{{ formFields.totalDaysPerMonth }}</th>
        </tr>
        <tr>
          <th>Total Hours Per Month</th>
          <th>{{ formFields.totalHoursPerMonth }}</th>
        </tr>
      </table>
      <br />
    <br />
      <table style="font-family: Lato, sans-serif; width: 680px; margin-left: 0px;" class="box3">
        <thead>
          <tr>
            <th>FINAL BREAKDOWN</th>
          </tr>
        </thead>
      </table>
      <br />
    <br />
      <table class="blueTable" style="font-family: Lato, sans-serif; font-weight: light; width: 680px">
        <tr>
          <th>Daily Cost</th>
          <th>${{ formFields.dailyCost }}</th>
        </tr>
        <tr>
          <th>Weekly Cost</th>
          <th>${{ formFields.weeklyCost }}</th>
        </tr>
        <tr>
          <th>Monthly Cost</th>
          <th>${{ formFields.monthlyCost }}</th>
        </tr>
        <tr>
          <th>Yearly Cost</th>
          <th>${{ formFields.yearlyCost }}</th>
        </tr>
      </table>
    </div> <!-- Closing the innermost wrapper div -->  
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <div class="footer-container">
        <img :src="images.footer" class="footercover" alt="Footer">
</div>
  </div> <!-- Closing the vertWrapper div -->
  

    </div>
    <div v-if="currentPage === 6" class="page">
      <div class="header">
        <p class="text">TERMS & CONDITIONS</p>
      </div>
      
      <p style="padding-left:35px;padding-right:35px;margin-top:0pt;margin-bottom:0pt;margin-left:0in;text-align:left;"><span style="font-size:16px;font-family: Lato, sans-serif;color:black;"><strong>TERMS & CONDITIONS:</strong> Unless agreed otherwise by us in writing, these terms and conditions (Terms and Conditions) shall apply to the provision of all goods and/or Services provided by us to you. These Terms and Conditions are the Terms and Conditions referred to in any correspondence with you or referred to in the Temporary Security Services Form or any other form, quotation, proposal or confirmation of request for services. We reserve the right to amend the Terms and Conditions from time to time by written notice to you. Your continued use of the Services will be deemed acceptance of such amended Terms and Conditions and such amended Terms and Conditions will replace any previous arrangements or understandings between you and Instaguard Security. 
</span><span style="font-size:16px;font-family: Lato, sans-serif;color:black;"></span></p>
<br>

<p style="padding-left:35px;padding-right:35px;margin-top:0pt;margin-bottom:0pt;margin-left:0in;text-align:left;"><span style="font-size:16px;font-family: Lato, sans-serif;color:black;"><strong>ACCEPTANCE:</strong> If: (a) we accept a request for goods and/or Services from you; and/or (b) you complete a Temporary Security Services Form and we accept that form; and/or (c) you accept a quote for goods and/or Services to be provided by us, that shall constitute acceptance of these Terms and Conditions and such request, quote or Temporary Security Services Form (as applicable) together with these Terms and Conditions shall constitute the agreement between you and us (the Agreement). Any variations or additions to the Agreement not expressly agreed in writing by us are expressly rejected by us.
 
</span><span style="font-size:16px;font-family: Lato, sans-serif;color:black;"></span></p>
<br>
<p style="padding-left:35px;padding-right:35px;margin-top:0pt;margin-bottom:0pt;margin-left:0in;text-align:left;"><span style="font-size:16px;font-family: Lato, sans-serif;color:black;"><strong>SECURITY SERVICES:</strong> We will provide to you the goods and/or Services specified in the Temporary Security Services Form (or, where the Agreement arises by way of a quotation or confirmation of request for Services, such quotation or confirmation of request for Services) and such further ancillary Services requested by you from time to time (including any request for us to deploy security guards to your Premises at any unscheduled time), provided that: (a) no security guard may be requested to provide Services to you for anything less than a four hour unbroken period; (b) no security guard will be deployed to your Premises unless a start and end time for the deployment has been agreed; (c) once we have agreed to deploy a security guard to your Premises, that deployment may not be cancelled by you unless you provide us with notice in writing of the cancellation: (i) in the case of Casual Services, at least four hours prior to the commencement of the deployment (and if you provide less than four hours’ notice, you shall be charged for all the scheduled hours of the deployment notwithstanding that such deployment may no longer be required and/or not occur); and (ii) in the case of Permanent Services, at least 30 days’ prior to the commencement of the last deployment (and if you provide less than 30 days’ notice, you shall be charged for all the scheduled hours of the deployment notwithstanding that such deployment may no longer be required and/or not occur); (d) we shall determine, in our sole discretion, the manner and means by which the Services are performed.
</span></p>
<br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
<div class="footer-container">
        <img :src="images.footer" class="footercover" alt="Footer">
</div>


    </div>

    <!-- Pagination Controls -->

</div>
</div>
    <v-btn @click="prevPage()">Previous</v-btn>
    <v-btn @click="nextPage()">Next</v-btn>
    <span class="page-counter">Page {{ currentPage }} of 6</span>
<br />
<br />
                  <v-card
                    class="theme-bg-card-5 card-animate"
                   >  

                   <v-form ref="proposalform" lazy-validation aria-autocomplete="off" class="form-control-2">
    <form ref="form" @submit.prevent="sendEmail">
      <v-row fluid>
        <v-button class="button">
          <v-toolbar-title style="padding: 0px;">
            <v-avatar size="60">
              <img src="@/assets/ReviewIcon.png" />
            </v-avatar>
            Proposal Email
          </v-toolbar-title>
          <div class="field">
            <label>Company</label>
            <input type="text" v-model="formFields.accountName" name="account_name" />
            <label>Contact</label>
            <input type="text" v-model="formFields.contactName" name="user_name" />
            <label>Email</label>
            <input type="email" v-model="formFields.email" name="user_email" />
            <label>Attach file:</label>
            <input type="file" name="my_file" @change="validateFile" />
            <span v-if="validFile" class="valid-file">&#10004;</span>
            <label>Closer</label>
                    <input type="text" v-model="formFields.proposalOwner" name="user_representative">
                    <label>Closer Email</label>
                    <input type="email" v-model="formFields.userEmail" name="user_representative_email">
                    <label>Closer Phone</label>
                    <input type="text" v-model="formFields.userPhone" name="user_representative_phone">
            <input class="submit" type="submit" @click="submitForm2" value="Send" />
            <span class="submit"></span>
            <span class="loading">
              <i class="fa fa-spinner fa-spin"></i>
            </span>
            <span class="check">
              <i class="fa fa-check"></i>
            </span>
          </div>
        </v-button>
      </v-row>
    </form>             
                </v-form>

                  </v-card>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      class="mx-4"
                      color="warning"
                      outlined
                      v-if="editForm"
                      :loading="loading3"
                      @click="createInvoice()"
                      >Generate Proposal</v-btn
                    >
                    <v-btn
                      class="mx-4"
                      color="red"
                      outlined
                      @click="resetForm()"
                      >Cancel</v-btn
                    >
                    <v-btn
                      class="mx-4"
                      color="green"
                      v-if="!editForm"
                      :loading="loading3"
                      :disabled="loading3"
                      outlined
                      @click="submitForm"
                      >Save</v-btn
                    >
                    <v-btn
                      class="mx-2"
                      color="green"
                      v-if="editForm"
                      :loading="loading3"
                      :disabled="loading3"
                      outlined
                      @click="updateProposal"
                      >Update</v-btn
                    >
                  </v-card-actions>
                </v-form>

              </v-list-item-content>
            </v-list-item>
          </v-flex>
        </v-layout>
      </v-card>
    </v-overlay>
    


  </v-content>
</template>

<script>
import { jsPDF } from "jspdf";
import html2canvas from 'html2canvas';
import { Bar } from 'vue-chartjs';
import { Base64 } from 'js-base64';
import emailjs from '@emailjs/browser';
import AccountForm from '@/components/AccountForm.vue';
import ContactForm from '@/components/ContactForm.vue';
import dateCommand from '../utility';
import goalAchieved from '@/assets/goalAchievednew.png';
import goalFailed from '@/assets/goalNotAchievednew.png';
// import goalCompletedImgSrc from '@/assets/goalAchievednew.png';
// import notCompletedImgSrc from '@/assets/goalNotAchievednew.png';
import dataZero from '@/assets/dataZero.png';
import startAudio from '@/assets/audio/SalesBell.wav';
export default {
name: 'Proposals',
components: {
  AccountForm,
  ContactForm,
  BarChart: {
    extends: Bar,
    props: ['data', 'options'],
    mounted () {
      this.renderChart(this.data, this.options)
    }
}
},
data() {
  return {
    images: {
  logo: require('./../assets/cell-funds-logo.png'),
  cover: require('./../assets/cover.jpg'),
  footerwelcome: require('./../assets/footer-welcome.jpg'),
  footer: require('./../assets/footer.png'),
},
    speak: 'Successfuly emailed Proposal',
    currentPage: 1,
    invoiceId: '',
    sortDesc: false,
    sortBy: 'fat',
    loading: false,
    loading2: false,
    showPopup: false,
    invoiceOwner: '',
    totalInvoices: 0,
    remainingToGoal: 0,
    goalAchieved,
    goalFailed,
    dataZero,
    invoiceOwners: [],
      ownerData: {},
      defaultGoal: 3,
    validFile: null,
    reportGenerated: false,
    reportType: '',
    originalData: [],
    activeFilters: [],
    leaderboard: [],
      startDate: '',
      endDate: '',
      offset: null,
      localDateISOString: '',
      menuStartDate: false,
      menuEndDate: false,
    fieldsToInclude: [],
    availableFields: [
    "Proposal ID",
    "Account Name",
    "Account Type",
    "Date",
    "Amount",
    "Status",
    ],
    scrollInvoked: 0,
    ownerOptions: [
      'John Salinas',
    ],
    dashboard: {},
    accountType: [
      'Business',
      'Personal',
      'Non-Profit',
    ],
    paymentType: ['Cash', 'Debit', 'Credit', 'Trade-In', 'Paypal', 'Check', 'Zelle', 'Acima'],
    proposalStatus: ['Created', 'Sent', 'Pending', 'Revised', 'Canceled', 'Accepted', 'Declined', 'Won', 'Lost'],
    items: [],
    contact_list: [],
    account_list: [],
    proposalsList: [],
    productsList: [],
    products: [],
    searchKey: '',
    search: '',
    searchAccountName: '',
    searchContactName: '',
    showAccountForm: false,
    showContactForm: false,
    optionIndex: 0,
    itemToBeDeleted: '',
    loading3: false,
    isLoading: false,
    productLoader: false,
    editForm: false,
    // selectAll: false,
    selectedInvoices: [],
    showConfirmation: false,
    showEmailConfirmation: false,
    overlay: false,
    overlay2: false,
    itemsPerPage: 10,
    currentField: 0,
    tableLoader: false,
    date: new Date().toISOString().substr(0, 10),
    selectedAccountDetails: {},
    selectedContactDetails: {},
    selectedProductInfo: {},
    selectedFields: [],
    statusMessage: '',
      leadOwner: this.$store.state.salesAssociates,
      salesAgent: this.$store.state.seniorSalesAssociates,
      userEmail: this.$store.state.email,
      filteredLeads: [],
      loggedInUserEmail: '',
      // userEmail: '',
      messageInfo: {
      message: "",
      messageColor: "success",
      timeoutDuration: 5000,
    },
      proposalOwnerData: this.proposalOwner,
      salesAgentData: this.salesAgent,
    formFields: {
      standingGuardRate: '',
      productName: '',
      Model: '',
      brand: '',
      Make: '',
      amount: '',
      quantity: '',
      price: '',
      serviceHours: '',
      daysFromWeek: '',
      holidayRate: '',
      golfCartRate: '',
      proposalSubject: '',
      proposalStatus: '',
      proposalOwner: '',
      accountName: '',
      firstName: '',
      lastName: '',
      company: '',
      contactName: '',
      accountType: '',
      paymentType: '',
      email: '',
      street: '',
      state: '',
      city: '',
      zipcode: '',
      totalDaysPerMonth: '',
      totalHoursPerMonth: '',
      hourlyCost: '',
      dailyCost: '',
      weeklyCost: '',
      monthlyCost: '',
      yearlyCost: '',
      salesAgent: '',
      leadOwner: '', 
      proposalDate: new Date().toISOString().substr(0, 10),
      proposalDue: '',
      subtotal: '',
      discount: 0,
      tax: 0,
      total: '',
      imei: '',
      productsList: [],
    },
    inputs: [
      {
      Make: '',
      Model: '',
      price: '',
      quantity: '',
      amount: '',
      IMEI: '',
      Memory: '',
      Carrier: '',
      Color: '',
      my_file: '',
      },
    ],
    modal_date_picker: false,
    form_valid: true,
    headers: [
      {
        text: 'Account Name',
        value: 'accountName',
        align: 'center',
        sortable: true,
        divider: true,
      },
      {
        text: 'Contact Name',
        value: 'contactName',
        align: 'center',
        sortable: true,
        divider: true,
      },
      // {
      //   text: 'Account Type',
      //   value: 'accountType',
      //   align: 'center',
      //   sortable: true,
      //   divider: true,
      // },
      {
        text: 'Date',
        value: 'proposalDate',
        align: 'center',
        sortable: true,
        divider: true,
      },
      {
        text: 'Grand Total',
        value: 'total',
        align: 'center',
        sortable: false,
        divider: true,
        itemsLength: 0,
      },
      // {
      //   text: 'Payment Type',
      //   value: 'paymentType',
      //   align: 'center',
      //   sortable: true,
      //   divider: true,
      // },
      // {
      //   text: 'Quantity',
      //   value: 'quantity',
      //   align: 'center',
      //   sortable: true,
      //   divider: true,
      // },
      {
        text: '',
        value: 'controls',
        align: 'center',
        sortable: false,
        divider: true,
      },
    ],
  };
},
created() {
    this.offset = new Date().getTimezoneOffset();
    let localDate = new Date(new Date().getTime() - this.offset * 60 * 1000);
    this.localDateISOString = localDate.toISOString().substr(0, 10);
    this.startDate = this.localDateISOString;
    this.endDate = this.localDateISOString;
  },
mounted() {
  this.initSpeechSynthesis();
  document.addEventListener('keydown', this.handleEscPress);
  // setTimeout(() => {
  //     this.$refs.Btn.click();
  //   }, 1000);
  Event.$on('showCard', (data) => {
    console.log(data);
    if (data.msg.indexOf('calendar') != -1) {
      this.type = 'calendar';
    }
    this.overlay = true;
  });
  Event.$on('showEmail', (data) => {
    if (this.$route.path !== '/proposals') {
      return;
    }
    console.log(data);
    if (data.msg.indexOf('email') != -1) {
      this.type = 'email';
    }
    this.overlay = true;
  });
  Event.$on('showApple', (data) => {
    if (this.$route.path !== '/proposals') {
      return;
    }
    console.log(data);
    if (data.msg.indexOf('apple') != -1) {
      this.type = 'apple';
    }
    this.overlay = true;
  });
  Event.$on('showSamsung', (data) => {
    if (this.$route.path !== '/proposals') {
      return;
    }
    console.log(data);
    if (data.msg.indexOf('samsung') != -1) {
      this.type = 'samsung';
    }
    this.overlay = true;
  });
  Event.$on('playMix', (data) => {
    if (this.$route.path !== '/proposals') {
      return;
    }
    console.log(data);
    if (data.msg.indexOf('mix') != -1) {
      this.type = 'mix';
    }
    this.overlay = true;
  });
  Event.$on('playNight', (data) => {
    if (this.$route.path !== '/proposals') {
      return;
    }
    console.log(data);
    if (data.msg.indexOf('night') != -1) {
      this.type = 'night';
    }
    this.overlay = true;
  });
  Event.$on('playChill', (data) => {
    if (this.$route.path !== '/proposals') {
      return;
    }
    console.log(data);
    if (data.msg.indexOf('chill') != -1) {
      this.type = 'chill';
    }
    this.overlay = true;
  });
  Event.$on('playSmooth', (data) => {
    if (this.$route.path !== '/proposals') {
      return;
    }
    console.log(data);
    if (data.msg.indexOf('smooth') != -1) {
      this.type = 'smooth';
    }
    this.overlay = true;
  });
  Event.$on('playCyber', (data) => {
    if (this.$route.path !== '/proposals') {
      return;
    }
    console.log(data);
    if (data.msg.indexOf('cyber') != -1) {
      this.type = 'cyber';
    }
    this.overlay = true;
  });
  Event.$on('closeCard', (data) => {
    if (this.$route.path !== '/proposals') {
      return;
    }
    console.log(data);
    this.overlay = false;
  });    
  this.getDashboard();
  this.getProposalsList();
  Event.$on('openForm', () => {
    // Event.$off();
    console.log('Starting form in ' + this.$route.path);
    if (this.$route.path !== '/proposals') {
      return;
    }
    this.readOutLoud('Please fill the following details');
    setTimeout(() => {
      this.readOutLoud('Company Name');
      this.startListining();
    }, 3000);
    this.overlay = true;
  });
  Event.$on('editFromRecord', (data) => {
    if (this.$route.path !== '/proposals') {
      return;
    }
    console.log(data.msg);
    this.editProposal(this.proposalsList[0]);
  });
  Event.$on('searchFromRecord', (data) => {
    if (this.$route.path !== '/proposals') {
      return;
    }
    this.search = data.msg;
    this.searchInvoice(data.msg);
  });
  Event.$on('generateProposal', (msg) => {
    if (this.$route.path !== '/proposals') {
      return;
    }
    console.log(msg);
    if (this.overlay) {
      this.createInvoice();
    }
  });
  Event.$on('formDetails', (data) => {
    console.log(data);
    switch (data.msg) {
      case 'next':
        this.currentField++;
        this.navigateField();
        break;
      case 'previous':
        this.currentField--;
        this.navigateField();
        break;
      case 'submit':
        this.readOutLoud('Please verify your proposal details');
        break;
      case 'verified':
        this.overlay = false;
        this.submitForm();
        break;
      default:
        this.fillForm(data.msg);
        break;
    }
  });
  const invoiceOwners = [];
    const ownerData = {
      "Owner 1": {
        header: "Header 1",
        content: "Content 1",
        grandTotal: "",
        totalQuantity: "",
        totalInvoices: "",
        goal: "",
      },
      "Owner 2": {
        header: "Header 2",
        content: "Content 2",
        grandTotal: "",
        totalQuantity: "",
        totalInvoices: "",
        goal: "",
      },
      "Owner 3": {
        header: "Header 3",
        content: "Content 3",
        grandTotal: "",
        totalQuantity: "",
        totalInvoices: "",
        goal: "",
      },
    };
    this.generateScoreboardReport();
    this.invoiceOwners = invoiceOwners;
    this.ownerData = ownerData;
  this.originalData = [...this.invoicesList];
},
printInvoice: function() {
  window.print();
},
watch: {
  reportType: {
  handler() {
    this.fetchData();
  },
  immediate: true
},
  selectedInvoices: {
    handler() {
      this.renderReport();
    },
    deep: true,
  },
  searchAccountName(val) {
    if (!val) return;
    this.isLoading = true;
    fetch(`${process.env.VUE_APP_NODE_SERVER}account-form/search`, {
      method: 'POST',
      body: JSON.stringify({ searchText: val }), // string or object
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    })
      .then((res) => res.clone().json())
      .then((res) => {
        this.account_list = res.result;
        this.isLoading = false;
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => (this.isLoading = false));
  },
  searchContactName(val) {
    // Items have already been loaded
    // if(!val) return
    // if (this.contact_list.length > 0) return;
    this.isLoading = true;
    fetch(`${process.env.VUE_APP_NODE_SERVER}contact-form/search`, {
      method: 'POST',
      body: JSON.stringify({ searchText: val }), // string or object
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    })
      .then((res) => res.clone().json())
      .then((res) => {
        this.contact_list = res.result;
        this.isLoading = false;
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => (this.isLoading = false));
  },
  selectedAccountDetails(val) {
    if (!val) return;
    this.formFields.email = val.email ? val.email : '';
    this.formFields.accountName = val.accountName ? val.accountName : '';
    this.formFields.firstName = val.firstName ? val.firstName : '';
    this.formFields.lastName = val.lastName ? val.lastName : '';
    this.formFields.street = val.street ? val.street : '';
    this.formFields.city = val.city ? val.city : '';
    this.formFields.state = val.state ? val.state : '';
    this.formFields.zipcode = val.zipcode ? val.zipcode : '';
    this.formFields.accountType = val.accountType ? val.accountType : '';
    this.contact_list.push(this.formFields);
    this.account_list.push(this.formFields);
  },
},
computed: {
  formattedProposalDate() {
      const options = { year: 'numeric', month: 'long', day: 'numeric' };
      return new Date(this.formFields.proposalDate).toLocaleDateString('en-US', options);
    },
  firstName() {
      return this.formFields.contactName.split(' ')[0];
    },
  isGoalAchieved() {
      return this.invoiceOwners.length >= this.defaultGoal;
    },
    sortedInvoiceOwners() {
    return this.invoiceOwners.slice().sort((a, b) => this.ownerData[b].totalInvoices - this.ownerData[a].totalInvoices);
  },
  generatedFilters() {
    let filters = {};

    // Iterate through each proposal and its properties to generate filter options
    this.proposalsList.forEach((proposal) => {
      for (let key in proposal) {
        if (!filters[key]) {
          filters[key] = new Set();
        }
        filters[key].add(proposal[key]);
      }
    });

    // Convert filter options to an array format suitable for the v-select component
    let filterArray = [];
    for (let key in filters) {
      filters[key].forEach((value) => {
        filterArray.push({ field: key, value: value, text: `${key}: ${value}` });
      });
    }

    return filterArray;
  },
  formattedHourlyCost() {
    return this.formatCurrency(this.formFields.hourlyCost);
  },
  formattedDailyCost() {
    return this.formatCurrency(this.formFields.dailyCost);
  },
  formattedWeeklyCost() {
    return this.formatCurrency(this.formFields.weeklyCost);
  },
  formattedMonthlyCost() {
    return this.formatCurrency(this.formFields.monthlyCost);
  },
  formattedYearlyCost() {
    return this.formatCurrency(this.formFields.yearlyCost);
  },
  formattedHolidayRate() {
    return this.formatCurrency(this.formFields.holidayRate);
  },
},
methods: {
  initSpeechSynthesis() {
    speechSynthesis.onvoiceschanged = () => {
      this.availableVoices = speechSynthesis.getVoices();
      
      // Filter available voices to match preferred voices and prepare voice options for selection
      this.voiceOptions = this.availableVoices
        .filter(voice => this.preferredVoices.includes(voice.name))
        .map(voice => ({ label: voice.name, value: voice.name }));
      
      // Automatically select the first preferred voice if available
      if (this.voiceOptions.length > 0) {
        this.selectedVoiceName = this.voiceOptions[0].value;
      }
    };
  },
  handleEscPress(event) {
      // Check if ESC key is pressed
      if (event.keyCode === 27) { // 27 is the keycode for ESC
        this.overlay = false;
      }
    },
  nextPage() {
      if (this.currentPage < 6) this.currentPage++;
    },
    prevPage() {
      if (this.currentPage > 1) this.currentPage--;
    },
  triggerConfettiAnimation() {
    // Trigger the confetti animation
    this.$refs.confetti.start();
  },
  updateGoal() {
  // Logic to update the goal
  // For this example, we'll assume the form input is stored in the 'defaultGoal' data property
  this.defaultGoal = parseInt(this.defaultGoal); // Convert the input to an integer

  // Perform any additional validation or data processing if needed

  // Clear the input field
  this.defaultGoal = '';

  // Check if the goal has been achieved after updating
  if (this.isGoalAchieved) {
    this.triggerConfettiAnimation();
  }
},
  calculateProfit() {
return this.inputs.map(product => {
  return product.amount - product.offer;
});
},

createChart(labels, data, chartRef) {
  this.$refs[chartRef].renderChart({
    labels: labels,
    datasets: [
      {
        label: 'Grand Total',
        backgroundColor: '#f87979',
        data: data
      }
    ]
  }, { responsive: true, maintainAspectRatio: false })
},
  // selectAllInvoices() {
  //   if (this.selectAll) {
  //     this.selectedInvoices = this.invoicesList.slice();
  //   } else {
  //     this.selectedInvoices = [];
  //   }
  // },
  dateInRange(date) {
    let invoiceDate = new Date(date);
    let startDate = new Date(this.dataStarting);
    let endDate = new Date(this.dataEnding);
    return invoiceDate >= startDate && invoiceDate <= endDate;
  },

  filtersMatch(invoice, activeFilters) {
    return activeFilters.every((filter) => {
      return invoice[filter.field] === filter.value;
    });
  },
  handleInputChange(field, event) {
    const value = parseFloat(event.target.value.replace(/[^0-9-.]/g, ''));
    if (!isNaN(value)) {
      this.formFields[field] = value;
      this.handleTotal();
    }
  },
  formatCurrency(value) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
    }).format(value);
  },
  exportToPdf() {
  const pdf = new jsPDF();

  const lineHeight = 10;
  const startingX = 20;
  const startingY = 20;

  pdf.setFontSize(14);

  pdf.text('Total Days per Month:', startingX, startingY);
  pdf.text(this.formFields.totalDaysPerMonth, startingX + 80, startingY);

  pdf.text('Total Hours per Month:', startingX, startingY + lineHeight);
  pdf.text(this.formFields.totalHoursPerMonth, startingX + 80, startingY + lineHeight);

  pdf.text('Daily Cost:', startingX, startingY + lineHeight * 2);
  pdf.text(this.formFields.dailyCost, startingX + 80, startingY + lineHeight * 2);

  pdf.text('Weekly Cost:', startingX, startingY + lineHeight * 3);
  pdf.text(this.formFields.weeklyCost, startingX + 80, startingY + lineHeight * 3);

  pdf.text('Monthly Cost:', startingX, startingY + lineHeight * 4);
  pdf.text(this.formFields.monthlyCost, startingX + 80, startingY + lineHeight * 4);

  pdf.text('Yearly Cost:', startingX, startingY + lineHeight * 5);
  pdf.text(this.formFields.yearlyCost, startingX + 80, startingY + lineHeight * 5);

  // Code 2 content integrated below:
  pdf.text('SECURITY OFFICERS:', startingX, startingY + lineHeight * 6);
  pdf.text(this.formFields.quantity, startingX + 80, startingY + lineHeight * 6);

  pdf.text('SERVICE DAYS:', startingX, startingY + lineHeight * 7);
  pdf.text(this.formFields.daysFromWeek, startingX + 80, startingY + lineHeight * 7);

  pdf.text('SERVICE HOURS:', startingX, startingY + lineHeight * 8);
  pdf.text(this.formFields.serviceHours, startingX + 80, startingY + lineHeight * 8);

  pdf.save('Cost_Report.pdf');
},

    validateFile(event) {
      const allowedExtensions = ["pdf", "png", "jpeg", "jpg"];
      const maxSize = 100 * 1024 * 1024; // 2 MB
      const file = event.target.files[0];
      const fileExtension = file.name.split(".").pop().toLowerCase();

      if (allowedExtensions.includes(fileExtension) && file.size <= maxSize) {
        this.validFile = true;
      } else {
        this.validFile = false;
        alert(
          "Invalid file type or size. Please upload a PDF, PNG, or JPEG file with a maximum size of 2 MB."
        );
      }
    },

  generateCsv(data, fields) {
    let header = fields.join(",") + "\n";
    let rows = data
      .map((row) => {
        return fields.map((field) => row[field]).join(",");
      })
      .join("\n");

    return header + rows;
  },
  sendEmail(event) {
      if (this.validFile) {
        event.preventDefault();
        emailjs.sendForm('service_instaguard', 'ig_proposal', this.$refs.form, 'LCgEjMAnZtdmEpC-4')
          .then((result) => {
              console.log('SUCCESS!', result.text);
          }, (error) => {
              console.log('FAILED...', error.text);
          });
      }
    },
  toggleOrder() {
    this.sortDesc = !this.sortDesc;
  },
  nextSort() {
    let index = this.headers.findIndex((h) => h.value === this.sortBy);
    index = (index + 1) % this.headers.length;
    this.sortBy = this.headers[index].value;
  },
  initialize() {
    this.ProposalsList = [];
  },
  getDashboard: async function() {
    const rawResponse = await fetch(
      `${process.env.VUE_APP_NODE_SERVER}analytics/all`
    );
    const content = await rawResponse.json();
    this.dashboard = content.response;
    console.log(content);
  },
  add() {
    this.inputs.push({
      Make: '',
      Model: '',
      price: '',
      quantity: '',
      amount: '',
      offer: '',
      IMEI: '',
      Memory: '',
      Carrier: '',
      Color: '',
    });
    console.log(this.inputs);
    this.productsList = [];
  },
  remove(index) {
    this.inputs.splice(index, 1);
    this.productsList = [];
  },
  onScroll() {
    this.scrollInvoked++;
  },
  selectProduct(product, i) {
    console.log(product);
    this.inputs[i].Make = product.Make;
    this.inputs[i].Model = product.Model;
    this.inputs[i].IMEI = product.IMEI;
    this.inputs[i].Memory = product.Memory;
    this.inputs[i].Carrier = product.Carrier;
    this.inputs[i].Color = product.Color;
    this.inputs[i].price = product.price;
    this.inputs[i].quantity = product.quantity;
    this.inputs[i].serviceHours = product.serviceHours;
    this.inputs[i].daysFromWeek = product.daysFromWeek;
    this.inputs[i].holidayRate = product.holidayRate;
    this.inputs[i].hourlyCost = product.hourlyCost;
    this.inputs[i].golfCartRate = product.golfCartRate;
    this.inputs[i].amount = product.amount;
    this.inputs[i].my_file = product.my_file;
    this.productsList = [];
    this.selectedProductInfo = product;
    this.type = '';
  },
  searchProducts(event, index, type) {
    if (!event.target.value) return;
    this.productLoader = true;
    this.optionIndex = index;
    this.type = type;
    if (type == 'product') {
      setTimeout(() => {
        fetch(`${process.env.VUE_APP_NODE_SERVER}product-master/search`, {
          method: 'POST',
          body: JSON.stringify({ searchText: event.target.value }), // string or object
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
        })
          .then((res) => res.clone().json())
          .then((res) => {
            this.productsList = res.result;
            this.productLoader = false;
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => (this.productLoader = false));
      }, 1000);
    } else if (type == 'imei') {
      setTimeout(() => {
        fetch(
          `${process.env.VUE_APP_NODE_SERVER}product-master/iemi-search`,
          {
            method: 'POST',
            body: JSON.stringify({ searchText: event.target.value }), // string or object
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
            },
          }
        )
          .then((res) => res.clone().json())
          .then((res) => {
            this.productsList = res.result;
            this.productLoader = false;
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => (this.productLoader = false));
      }, 1000);
    }
  },
  
  handleTotal() {
  if (this.inputs.length) {
    let totalDaysPerMonth = 0;
    let totalHoursPerMonth = 0;

    this.formFields.subtotal = this.inputs.reduce((accum, item) => {
      const itemTotal = item.amount * item.quantity * item.daysFromWeek * item.serviceHours;
      
      // Calculate total days and hours per month
      totalDaysPerMonth += item.daysFromWeek * 4;
      totalHoursPerMonth += item.daysFromWeek * 4 * item.serviceHours;

      return accum + itemTotal;
    }, 0);
    this.formFields.hourlyCost = this.inputs.reduce((accum, item) => {
  return accum + item.amount; // Assuming item.amount represents an hourly rate
}, 0).toLocaleString('en-US', { style: 'currency', currency: 'USD' });

    this.formFields.dailyCost = this.inputs.reduce((accum, item) => {
      const itemTotal = item.amount * item.quantity * item.serviceHours;
      return accum + itemTotal;
    }, 0);
    this.formFields.weeklyCost = this.inputs.reduce((accum, item) => {
      const itemTotal = item.amount * item.quantity * item.daysFromWeek * item.serviceHours;
      return accum + itemTotal;
    }, 0);
    
    this.formFields.totalDaysPerMonth = totalDaysPerMonth;
    this.formFields.totalHoursPerMonth = totalHoursPerMonth;


    // Calculate daily, weekly, monthly, and yearly costs
    // this.formFields.monthlyCost = this.formFields.weeklyCost * 4;
    // this.formFields.yearlyCost = this.formFields.monthlyCost * 12;
    this.formFields.dailyCost = (this.formFields.subtotal / totalDaysPerMonth).toFixed(2);
    this.formFields.weeklyCost = (this.formFields.dailyCost * 7).toFixed(2);
    this.formFields.monthlyCost = (this.formFields.weeklyCost * 4).toFixed(2);
this.formFields.yearlyCost = (this.formFields.monthlyCost * 12).toFixed(2);

    // Calculate the final total with taxes and discount
    this.formFields.total =
      this.formFields.subtotal * this.formFields.tax / 100 +
      this.formFields.subtotal -
      this.formFields.discount;

      this.formFields.holidayRate = this.inputs[0].holidayRate;
      this.formFields.golfCartRate = this.inputs[0].golfCartRate;
      this.formFields.serviceHours = this.inputs[0].serviceHours;
      this.formFields.daysFromWeek = this.inputs[0].daysFromWeek;
  }
},
  searchInvoice: async function() {
    console.log(this.search);
    this.isLoading = true;

    if (this.search) this.getInvoicesList();
    const response = await fetch(
      `${process.env.VUE_APP_NODE_SERVER}invoice-form/search`,
      {
        method: 'POST',
        body: JSON.stringify({ searchText: this.search }), // string or object
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      }
    );
    const json = await response.json();
    this.isLoading = false;
    console.log(json);
    this.invoicesList = json.result;

    let filteredData = this.originalData.filter((item) => {
      let dateCondition = true;
      if (this.startDate && this.endDate) {
        const itemDate = new Date(item.date);
        const startDate = new Date(this.startDate);
        const endDate = new Date(this.endDate);
        dateCondition = itemDate >= startDate && itemDate <= endDate;
      }

      let queryCondition = true;
      if (this.query) {
        queryCondition = item.name.toLowerCase().includes(this.query.toLowerCase());
      }

      return dateCondition && queryCondition;
    });

    this.invoicesList = filteredData;
    this.$emit('searchInvoice', this.invoicesList);
  },
  searchProposal: async function() {
    console.log(this.search);
    if (!this.search) this.getProposalsList();
    this.isLoading = true;
    const response = await fetch(
      `${process.env.VUE_APP_NODE_SERVER}proposals/search`,
      {
        method: 'POST',
        body: JSON.stringify({ searchText: this.search }), // string or object
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      }
    );
    const json = await response.json();
    this.isLoading = false;
    console.log(json);
    this.proposalsList = json.result;
  },
  generateReport() {
let csvContent;
if (this.reportType === 'Proposal Report') {
  csvContent = this.generateSalesReport();
} else if (this.reportType === 'Profit Margins Report') {
  csvContent = this.generateProfitMarginsReport();
} else if (this.reportType === 'Proposal Owner Report') {
  csvContent = this.generateProposalOwnerReport();
}

let csvRows = csvContent.split("\n");
let htmlRows = csvRows.map(row => {
  let columns = row.split(",");
  return `<tr>${columns.map(column => `<td>${column}</td>`).join('')}</tr>`;
}).join('');

let htmlContent = `
<html>
<head>
  <style>
  body{
background: -webkit-linear-gradient(left, #29343a, #2d4552);
background: linear-gradient(to right, #29343a, #2d4552);
font-family: 'Roboto', sans-serif;
}
      table {
          border-collapse: collapse;
          margin: 20px auto;
          background-color: rgba(255, 255, 255, 0.1);
      }

      h1{
font-size: 30px;
color: #fff;
text-transform: uppercase;
font-weight: 300;
text-align: center;
margin-bottom: 15px;
}
table{
width:100%;
table-layout: fixed;
}
.tbl-header{
margin-top: 50px;
background-color: rgba(255,255,255,0.3);
}
.tbl-content{
height:300px;
overflow-x:auto;
margin-top: 0px;
border: 1px solid rgba(255,255,255,0.3);
}
th{
padding: 20px 15px;
text-align: left;
font-weight: 500;
font-size: 12px;
color: #fff;
text-transform: uppercase;
}
td{
padding: 15px;
text-align: left;
vertical-align:middle;
font-weight: 300;
font-size: 12px;
color: #fff;
border-bottom: solid 1px rgba(255,255,255,0.1);
}

  </style>
</head>
<body>
  <h1>${this.reportType}</h1>
  <table>
      ${htmlRows}
  </table>
</body>
</html>`;


let blob = new Blob([htmlContent], { type: "text/html" });
let url = URL.createObjectURL(blob);

this.$refs.outputIframe.src = url;
this.reportGenerated = true;
const outputIframe = document.querySelector(".data-table-iframe");

// Replace this with your actual condition
const shouldShowDataTable = true;

if (shouldShowDataTable) {
outputIframe.classList.add("show-data-table");
} else {
outputIframe.classList.remove("show-data-table");
}

},

generateProposalOwnerReport() {
let proposalOwners = [...new Set(this.proposalsList.map(proposal => proposal.proposalOwner))];
let ownerData = {};

proposalOwners.forEach((proposalOwner) => {
  ownerData[proposalOwner] = {
    header: ["ProposalOwner", ...this.headers.map((header) => header.text)].join(","),
    content: "",
    grandTotal: 0,
    totalQuantity: 0,
    totalProposals: 0
  };
});

let filteredProposals = this.proposalsList.filter((proposal) => {
  let dateCondition = true;
  if (this.startDate && this.endDate) {
    const proposalDate = new Date(proposal.proposalDate);
    const startDate = new Date(this.startDate);
    const endDate = new Date(this.endDate);
    dateCondition = proposalDate >= startDate && proposalDate <= endDate;
  }
  return dateCondition;
});

filteredProposals.forEach((proposal) => {
  let proposalOwner = proposal.proposalOwner;
  let rowData = [proposalOwner, ...this.headers.map((header) => proposal[header.value])].join(",");
  if (Object.prototype.hasOwnProperty.call(ownerData, proposalOwner)) {
    ownerData[proposalOwner].content += rowData + "\r\n";
    ownerData[proposalOwner].grandTotal += proposal.total;
    ownerData[proposalOwner].totalQuantity += proposal.quantity;
    ownerData[proposalOwner].totalProposals++;
  }
});

let csvContent = "data:text/csv;charset=utf-8,";
proposalOwners.forEach((owner) => {
  csvContent += `ProposalOwner: ${owner}\r\n`;
  csvContent += ownerData[owner].header + "\r\n";
  csvContent += ownerData[owner].content;
  csvContent += "Grand Total," + ownerData[owner].grandTotal + "\r\n";
  csvContent += "Total Quantity," + ownerData[owner].totalQuantity + "\r\n";
  csvContent += "Total Proposals," + ownerData[owner].totalProposals + "\r\n";
  csvContent += "\r\n";
});
this.createChart(proposalOwners, proposalOwners.map(owner => ownerData[owner].grandTotal), 'proposalOwnerChart');
return csvContent;
},

generateSalesReport() {
let accountTypes = ["Business", "Personal", "Non-Profit"];
let accountData = {};

accountTypes.forEach((type) => {
  accountData[type] = {
    header: this.headers.map((header) => header.text).join(","),
    content: "",
    grandTotal: 0,
    totalQuantity: 0,
  };
});

let filteredProposals = this.proposalsList.filter((proposal) => {
  let dateCondition = true;
  if (this.startDate && this.endDate) {
    const proposalDate = new Date(proposal.proposalDate);
    const startDate = new Date(this.startDate);
    const endDate = new Date(this.endDate);
    dateCondition = proposalDate >= startDate && proposalDate <= endDate;
  }
  return dateCondition;
});

filteredProposals.forEach((row) => {
  let rowData = this.headers.map((header) => row[header.value]).join(",");
  let accountType = row.accountType;
  if (Object.prototype.hasOwnProperty.call(accountData, accountType)) {
    accountData[accountType].content += rowData + "\r\n";
    accountData[accountType].grandTotal += row.total;
    accountData[accountType].totalQuantity += row.quantity;
  }
});

let csvContent = "data:text/csv;charset=utf-8,";
accountTypes.forEach((type) => {
  csvContent += `Account Type: ${type}\r\n`;
  csvContent += accountData[type].header + "\r\n";
  csvContent += accountData[type].content;
  csvContent += "Grand Total," + accountData[type].grandTotal + "\r\n";
  csvContent += "Total Quantity," + accountData[type].totalQuantity + "\r\n";
  csvContent += "\r\n";
});
this.createChart(accountTypes, accountTypes.map(type => accountData[type].grandTotal), 'salesChart');
return csvContent;

},

generateProfitMarginsReport() {
let accountData = {
  productsList: {
    header: this.headers.map((header) => header.text)
      .concat(["Offer", "Selling Price", "Profit", "Margin Percentage"])
      .join(","),
    content: "",
    grandTotal: 0,
    totalQuantity: 0,
    totalOffer: 0,
    totalProfit: 0,
  },
};

// Find the matching product data from the searchProducts results
const findMatchingProduct = (imei) => {
  return this.productsList.find((product) => product.IMEI === imei);
};

let filteredProposals = this.proposalsList.filter((proposal) => {
  let dateCondition = true;
  if (this.startDate && this.endDate) {
    const proposalDate = new Date(proposal.proposalDate);
    const startDate = new Date(this.startDate);
    const endDate = new Date(this.endDate);
    dateCondition = proposalDate >= startDate && proposalDate <= endDate;
  }
  return dateCondition;
});

filteredProposals.forEach((row) => {
  let product = findMatchingProduct(row.IMEI);
  let offer = 0;
  let profit = 0;
  let marginPercentage = 0;
  let sellingPrice = 0;

  if (product) {
    offer = product.offer;
    sellingPrice = product.price ? product.price : row.formFiles.amount; // Update Selling Price if available
    profit = sellingPrice - offer;
    marginPercentage = (profit / sellingPrice) * 100;
  }

  let rowData = this.headers
    .map((header) => row[header.value])
    .concat([offer, sellingPrice, profit, marginPercentage.toFixed(2) + "%"])
    .join(",");

  accountData.productsList.content += rowData + "\r\n";
  accountData.productsList.grandTotal += sellingPrice;
  accountData.productsList.totalQuantity += row.quantity;
  accountData.productsList.totalOffer += offer;
  accountData.productsList.totalProfit += profit;
});

let csvContent = "data:text/csv;charset=utf-8,";
csvContent += accountData.productsList.header + "\r\n";
csvContent += accountData.productsList.content;
csvContent += "Total Offer," + accountData.productsList.totalOffer + "\r\n";
csvContent += "Grand Total," + accountData.productsList.grandTotal + "\r\n";
csvContent += "Total Profit," + accountData.productsList.totalProfit + "\r\n";
csvContent += "Total Quantity," + accountData.productsList.totalQuantity + "\r\n";
this.createChart(['Products'], [accountData.productsList.grandTotal], 'profitMarginsChart');

return csvContent;
},

// generateProfitMarginsReport() {
//   let profitMargins = ["0-10%", "10-20%", "20-30%", "30-40%", "40-50%", "50-60%", "60-70%", "70-80%", "80-90%", "90-100%"];
//   let profitMarginData = {};

//   profitMargins.forEach((margin) => {
//     profitMarginData[margin] = {
//       header: this.headers.map((header) => header.text).join(","),
//       content: "",
//       grandTotal: 0,
//       totalQuantity: 0,
//     };
//   });

//   let filteredInvoices = this.invoicesList.filter((invoice) => {
//     let dateCondition = true;
//     if (this.startDate && this.endDate) {
//       const invoiceDate = new Date(invoice.invoiceDate);
//       const startDate = new Date(this.startDate);
//       const endDate = new Date(this.endDate);
//       dateCondition = invoiceDate >= startDate && invoiceDate <= endDate;
//     }
//     return dateCondition;
//   });

//   filteredInvoices.forEach((row) => {
//     let rowData = this.headers.map((header) => row[header.value]).join(",");
//     let profitMargin = row.profitMargin;
//     if (Object.prototype.hasOwnProperty.call(profitMarginData, profitMargin)) {
//       profitMarginData[profitMargin].content += rowData + "\r\n";
//       profitMarginData[profitMargin].grandTotal += row.total;
//       profitMarginData[profitMargin].totalQuantity += row.quantity;
//     }
//   });

//   let csvContent = "data:text/csv;charset=utf-8,";
//   profitMargins.forEach((margin) => {
//     csvContent += `Profit Margin: ${margin}\r\n`;
//     csvContent += profitMarginData[margin].header + "\r\n";
//     csvContent += profitMarginData[margin].content;
//     csvContent += "Grand Total," + profitMarginData[margin].grandTotal + "\r\n";
//     csvContent += "Total Quantity," + profitMarginData[margin].totalQuantity + "\r\n";
//     csvContent += "\r\n";
//   });

//   return csvContent;
// },
downloadReport() {
let filteredProposals = this.proposalsList.filter((proposal) => {
  let dateCondition = true;
  if (this.startDate && this.endDate) {
    const proposalDate = new Date(proposal.proposalDate);
    const startDate = new Date(this.startDate);
    const endDate = new Date(this.endDate);
    dateCondition = proposalDate >= startDate && proposalDate <= endDate;
  }
  return dateCondition;
});

let csvContent = "data:text/csv;charset=utf-8,";
let header = this.headers.map((header) => header.text).join(",");
csvContent += header + "\r\n";

filteredProposals.forEach((row) => {
  let rowData = this.headers.map((header) => row[header.value]).join(",");
  csvContent += rowData + "\r\n";
});

let encodedUri = encodeURI(csvContent);
let link = document.createElement("a");
link.setAttribute("href", encodedUri);
link.setAttribute("download", "general_report.csv");
document.body.appendChild(link);
link.click();
document.body.removeChild(link);

if (this.reportType === 'Proposal Report') {
  this.downloadSalesReport(filteredProposals);
} else if (this.reportType === 'Profit Margins Report') {
  this.downloadProfitMarginsReport(filteredProposals);
} else if (this.reportType === 'Proposal Owner Report') {
  this.downloadProposalOwnerReport(filteredProposals);
}
},

downloadProposalOwnerReport() {
let proposalOwners = [...new Set(this.proposalsList.map(proposal => proposal.proposalOwner))];
let ownerData = {};

proposalOwners.forEach((proposalOwner) => {
  ownerData[proposalOwner] = {
    header: ["ProposalOwner", ...this.headers.map((header) => header.text)].join(","),
    content: "",
    grandTotal: 0,
    totalQuantity: 0,
    totalProposals: 0
  };
});

let filteredProposals = this.proposalsList.filter((proposal) => {
  let dateCondition = true;
  if (this.startDate && this.endDate) {
    const proposalDate = new Date(proposal.proposalDate);
    const startDate = new Date(this.startDate);
    const endDate = new Date(this.endDate);
    dateCondition = proposalDate >= startDate && proposalDate <= endDate;
  }
  return dateCondition;
});

filteredProposals.forEach((proposal) => {
  let proposalOwner = proposal.proposalOwner;
  let rowData = [proposalOwner, ...this.headers.map((header) => proposal[header.value])].join(",");
  if (Object.prototype.hasOwnProperty.call(ownerData, proposalOwner)) {
    ownerData[proposalOwner].content += rowData + "\r\n";
    ownerData[proposalOwner].grandTotal += proposal.total;
    ownerData[proposalOwner].totalQuantity += proposal.quantity;
    ownerData[proposalOwner].totalProposals++;
  }
});

let csvContent = "data:text/csv;charset=utf-8,";
proposalOwners.forEach((owner) => {
  csvContent += `ProposalOwner: ${owner}\r\n`;
  csvContent += ownerData[owner].header + "\r\n";
  csvContent += ownerData[owner].content;
  csvContent += "Grand Total," + ownerData[owner].grandTotal + "\r\n";
  csvContent += "Total Quantity," + ownerData[owner].totalQuantity + "\r\n";
  csvContent += "Total Proposals," + ownerData[owner].totalProposals + "\r\n";
  csvContent += "\r\n";
});

let encodedUri = encodeURI(csvContent);
let link = document.createElement("a");
link.setAttribute("href", encodedUri);
link.setAttribute("download", "ProposalOwner_report.csv");
document.body.appendChild(link);
link.click();
document.body.removeChild(link);
return csvContent;
},

downloadSalesReport(filteredProposals) {
let accountTypes = ["Business", "Personal", "Non-Profit"];
let accountData = {};

accountTypes.forEach((type) => {
  accountData[type] = {
    header: this.headers.map((header) => header.text).join(","),
    content: "",
    grandTotal: 0,
    totalQuantity: 0,
  };
});

filteredProposals.forEach((row) => {
  let rowData = this.headers.map((header) => row[header.value]).join(",");
  let accountType = row.accountType;
  if (Object.prototype.hasOwnProperty.call(accountData, accountType)) {
    accountData[accountType].content += rowData + "\r\n";
    accountData[accountType].grandTotal += row.total;
    accountData[accountType].totalQuantity += row.quantity;
  }
});

let csvContent = "data:text/csv;charset=utf-8,";
accountTypes.forEach((type) => {
  csvContent += `Account Type: ${type}\r\n`;
  csvContent += accountData[type].header + "\r\n";
  csvContent += accountData[type].content;
  csvContent += "Grand Total," + accountData[type].grandTotal + "\r\n";
  csvContent += "Total Quantity," + accountData[type].totalQuantity + "\r\n";
  csvContent += "\r\n";
});

let encodedUri = encodeURI(csvContent);
let link = document.createElement("a");
link.setAttribute("href", encodedUri);
link.setAttribute("download", "sales_report.csv");
document.body.appendChild(link);
link.click();
document.body.removeChild(link);
return csvContent;
},
downloadProfitMarginsReport(filteredProposals) {
let accountData = {
  productsList: {
    header: this.headers.map((header) => header.text)
      .concat(["Offer", "Selling Price", "Profit", "Margin Percentage"])
      .join(","),
    content: "",
    grandTotal: 0,
    totalQuantity: 0,
    totalOffer: 0,
    totalProfit: 0,
  },
};

// Find the matching product data from the searchProducts results
const findMatchingProduct = (imei) => {
  return this.productsList.find((product) => product.IMEI === imei);
};

filteredProposals.forEach((row) => {
  let product = findMatchingProduct(row.IMEI);
  let offer = 0;
  let profit = 0;
  let marginPercentage = 0;
  let sellingPrice = 0;

  if (product) {
    offer = product.offer;
    sellingPrice = product.price ? product.price : row.formFiles.amount; // Update Selling Price if available
    profit = sellingPrice - offer;
    marginPercentage = (profit / sellingPrice) * 100;
  }

  let rowData = this.headers
    .map((header) => row[header.value])
    .concat([offer, sellingPrice, profit, marginPercentage.toFixed(2) + "%"])
    .join(",");

  accountData.productsList.content += rowData + "\r\n";
  accountData.productsList.grandTotal += sellingPrice;
  accountData.productsList.totalQuantity += row.quantity;
  accountData.productsList.totalOffer += offer;
  accountData.productsList.totalProfit += profit;
});

let csvContent = "data:text/csv;charset=utf-8,";
csvContent += accountData.productsList.header + "\r\n";
csvContent += accountData.productsList.content;
csvContent += "Total Offer," + accountData.productsList.totalOffer + "\r\n";
csvContent += "Grand Total," + accountData.productsList.grandTotal + "\r\n";
csvContent += "Total Profit," + accountData.productsList.totalProfit + "\r\n";
csvContent += "Total Quantity," + accountData.productsList.totalQuantity + "\r\n";

let encodedUri = encodeURI(csvContent);
let link = document.createElement("a");
link.setAttribute("href", encodedUri);
link.setAttribute("download", "profit_margins_report.csv");
document.body.appendChild(link);
link.click();
document.body.removeChild(link);
return csvContent;
},

  getInvoicesList: async function() {
    this.tableLoader = true;
    const response = await fetch(
      `${process.env.VUE_APP_NODE_SERVER}invoice-form/all`
    );
    const json = await response.json();
    console.log(json);
    this.invoicesList = json.result;
    this.dashboard.accounts = this.invoicesList.reduce(
      (acc, o) => ((acc[o.accountName] = (acc[o.accountName] || 0) + 1), acc),
      {}
    );
    this.dashboard.accounts = Object.keys(this.dashboard.accounts).length;
    this.dashboard.invoices = this.invoicesList.length;
    this.dashboard.products = this.invoicesList.length;
    this.tableLoader = false;
  },
  getProposalsList: async function() {
    this.tableLoader = true;
    const response = await fetch(
      `${process.env.VUE_APP_NODE_SERVER}proposals/all`
    );
    const json = await response.json();
    console.log(json);
    this.proposalsList = json.result;
    this.dashboard.accounts = this.proposalsList.reduce(
      (acc, o) => ((acc[o.accountName] = (acc[o.accountName] || 0) + 1), acc),
      {}
    );
    this.dashboard.accounts = Object.keys(this.dashboard.accounts).length;
    this.tableLoader = false;
  },
  submitForm2: async function() {
    this.isLoading = true;
    setTimeout(() => {
      this.readOutLoud('Successfuly emailed Proposal');
      this.buttonLoader = true;
      this.showEmailConfirmation = true;
      this.resetForm();
    }, 2000);
  },
  submitForm: async function() {
    console.log(this.formFields);
    // console.log(this.inputs[0])
    this.formFields.accountName = this.selectedAccountDetails.accountName;
    this.formFields.contactName = this.selectedContactDetails.contactName;
    if (!this.inputs[0].Make) {
      this.$notify({
        group: 'foo',
        title: 'Important message',
        text: 'Please add products',
      });
      return;
    }
    console.log(this.selectedAccountDetails);
    console.log(this.selectedContactDetails);
    this.formFields.productsList = this.inputs;
    this.formFields.quantity = this.inputs.length;
    this.loading3 = true;
    const response = await fetch(
      `${process.env.VUE_APP_NODE_SERVER}proposals/create`,
      {
        method: 'POST',
        body: JSON.stringify({ ...this.formFields }), // string or object
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      }
    );
    const json = await response.json(); //extract JSON from the http response
    console.log(json[0]);

    setTimeout(() => {
      this.readOutLoud('Proposal Created');
      this.getProposalsList();
      this.resetForm();

      this.$confetti.start();

      new Audio(startAudio).play();
      // Stop the confetti after 5 seconds
      setTimeout(() => {
        this.$confetti.stop();
      }, 5000);
    }, 800);
    this.updateProductStatus();
    this.loading3 = false;
  },
  deleteConfirmation: function(item) {
    this.itemToBeDeleted = item;
    this.showConfirmation = true;
  },
  deleteProposal: async function() {
    this.loading3 = true;
    const response = await fetch(
      `${process.env.VUE_APP_NODE_SERVER}proposals/delete`,
      {
        method: 'POST',
        body: JSON.stringify({ id: this.itemToBeDeleted._id }), // string or object
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      }
    );
    const json = await response.json(); //extract JSON from the http response
    console.log(json[0]);
    this.itemToBeDeleted = '';
    this.showConfirmation = false;
    this.loading3 = false;
    setTimeout(() => {
      this.readOutLoud('1 record deleted');
      this.getProposalsList();
    }, 800);
  },
  editProposal: function(data) {
    this.overlay = true;
    this.editForm = true;
    this.formFields = data;
    this.inputs = data.productsList;
    this.selectedAccountDetails = this.formFields;
    this.selectedContactDetails = this.formFields;
    console.log(this.formFields.accountName);
    console.log(this.formFields.contactName);
  },
  updateProposal: async function() {
    this.loading3 = true;
    this.formFields.accountName = this.selectedAccountDetails.accountName;
    this.formFields.contactName = this.selectedContactDetails.contactName;
    const response = await fetch(
      `${process.env.VUE_APP_NODE_SERVER}proposals/update`,
      {
        method: 'POST',
        body: JSON.stringify(this.formFields), // string or object
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      }
    );
    const json = await response.json(); //extract JSON from the http response
    console.log(json[0]);
    setTimeout(() => {
      this.readOutLoud('1 record updated');
      this.getProposalsList();
      this.resetForm();
    }, 800);
  },
  resetForm: function() {
    this.overlay = false;
    this.editForm = false;
    this.loading3 = false;
    this.inputs = [
      {
        Make: '',
      Model: '',
      price: '',
      quantity: '',
      amount: '',
      IMEI: '',
      Memory: '',
      Carrier: '',
      Color: '',
      my_file: '',
      },
    ];
    this.formFields = {
      standingGuardRate: '',
      model: '',
      Amount: '',
      quantity: '',
      Price: '',
      serviceHours: '',
      daysFromWeek: '',
      holidayRate: '',
      golfCartRate: '',
      proposalSubject: '',
      proposalStatus: '',
      proposalOwner: '',
      accountName: '',
      firstName: '',
      lastName: '',
      company: '',
      contactName: '',
      accountType: '',
      paymentType: '',
      email: '',
      street: '',
      state: '',
      city: '',
      zipcode: '',
      totalDaysPerMonth: '',
      totalHoursPerMonth: '',
      hourlyCost: '',
      dailyCost: '',
      weeklyCost: '',
      monthlyCost: '',
      yearlyCost: '',
      proposalDate: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
      proposalDue: '',
      subtotal: '',
      discount: 0,
      tax: 0,
      total: '',
      imei: '',
      productsList: [],
    };
  },
  openForm: function() {
    this.overlay = true;
    this.items = [];
    this.selectedProductInfo = [];
  },
  startListining: function() {
    setTimeout(() => {
      Event.$emit('speakModeOn');
    }, 1250);
  },
  beforeDestroy() {
    Event.$off('speakModeOn');
    Event.$off('openForm');
    Event.$off('searchFromRecord');
    Event.$off('editFromRecord');
    document.removeEventListener('keydown', this.handleEscPress);
  },
  readOutLoud: function(msg) {
    const speech = new SpeechSynthesisUtterance();
    const voiceName = 'Google UK English Male';
    speech.volume = 1;
    speech.rate = 1;
    speech.pitch = 1;
    speech.voice = speechSynthesis.getVoices().filter(function (voice) {
    return voice.name === voiceName
  })[0]
    speech.text = msg;
    window.speechSynthesis.speak(speech);
   
  },
  fillForm: function(msg) {
    switch (this.currentField) {
      case 0:
        //Owner Name
        var owner = this.ownerOptions.filter(
          (obj) => obj.toLowerCase() == msg.toLowerCase()
        )[0];
        if (owner) {
          this.formFields.proposalOwner = owner;
          this.currentField++;
        } else {
          this.readOutLoud('Unable to find from list, please try again');
        }
        break;
      case 1:
        this.formFields.proposalDate = dateCommand(msg);
        this.currentField++;
        break;
      case 2:
        this.formFields.proposalSubject = msg;
        this.currentField++;
        break;
      case 3:
        var accountType = this.accountType.filter(
          (obj) => obj.toLowerCase() == msg.toLowerCase()
        )[0];
        if (accountType) {
          this.formFields.accountType = accountType;
          this.currentField++;
        } else {
          this.readOutLoud('Unable to find from list, please try again');
        }
        break;
      case 4:
        this.formFields.accountName = msg;
        this.currentField++;
        break;
      case 5:
        var paymentType = this.paymentType.filter(
          (obj) => obj.toLowerCase() == msg.toLowerCase()
        )[0];
        if (paymentType) {
          this.formFields.paymentType = paymentType;
          this.currentField++;
        } else {
          this.readOutLoud('Unable to find from list, please try again');
        }
        break;
      case 6:
        this.formFields.contactName = msg;
        this.currentField++;
        break;
      case 7:
        var proposalStatus = this.proposalStatus.filter(
          (obj) => obj.toLowerCase() == msg.toLowerCase()
        )[0];
        if (proposalStatus) {
          this.formFields.proposalStatus = proposalStatus;
          this.currentField++;
        } else {
          this.readOutLoud('Unable to find from list, please try again');
        }
        break;
      case 8:
        this.formFields.street = msg;
        this.currentField++;
        break;
      case 9:
        this.formFields.state = msg;
        this.currentField++;
        break;
      case 10:
        this.formFields.city = msg;
        this.currentField++;
        break;
      case 11:
        this.formFields.zipcode = msg;
        this.currentField++;
        break;
      case 12:
        this.input.IMEI = msg;
        this.currentField++;
        break;
    }
    this.navigateField();
  },
  navigateField: function() {
    console.log(this.currentField);
    switch (this.currentField) {
      case 0:
        this.readOutLoud('Proposal Owner?');
        break;
      case 1:
        this.readOutLoud('Proposal Date?');
        break;
      case 2:
        this.readOutLoud('Proposal Subject?');
        break;
      case 3:
        this.readOutLoud('Account Type?');
        break;
      case 4:
        this.readOutLoud('Account Name?');
        break;
      case 5:
        this.readOutLoud('Payment Type?');
        break;
      case 6:
        this.readOutLoud('Contact Name?');
        break;
      case 7:
        this.readOutLoud('Proposal Status?');
        break;
      case 8:
        this.readOutLoud('Street?');
        break;
      case 9:
        this.readOutLoud('State ?');
        break;
      case 10:
        this.readOutLoud('City ?');
        break;
      case 11:
        this.readOutLoud('Zip code ?');
        break;
      case 12:
        this.readOutLoud('IMEI?');
        break;
    }
    this.startListining();
  },
// async createInvoice() {
//   this.loading3 = true;
//   const invoiceData = this.getSampleData();
//   this.invoiceContent = invoiceData;

//   this.inputs.forEach(input => {
//     input.description = `MODEL: ${input.Make} ${input.Model} IMEI: ${input.IMEI}`;
//   });

//   this.$nextTick(async () => {
//     const invoiceElement = document.getElementById('invoice-preview');
//     if (!invoiceElement) {
//       this.loading3 = false;
//       return;
//     }

//     try {
//       const canvas = await html2canvas(invoiceElement, {
//         scale: 2, // Adjust for better quality; consider performance implications
//         useCORS: true,
//         logging: true,
//         windowHeight: document.body.scrollHeight,
//         windowWidth: document.body.scrollWidth
//       });

//       const imgData = canvas.toDataURL('image/png');
//       const pdf = new jsPDF({
//         orientation: 'p',
//         unit: 'pt',
//         format: 'letter'
//       });

//       // Calculate the necessary scaling to fit the content within the PDF page width.
//       const imgWidth = 8.5 * 72; // 8.5 inches width for letter size
//       const imgHeight = canvas.height * imgWidth / canvas.width;
//       let heightLeft = imgHeight;
//       let position = 0;

//       pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
//       heightLeft -= pdf.internal.pageSize.getHeight();

//       while (heightLeft >= 0) {
//         position = heightLeft - imgHeight;
//         pdf.addPage();
//         pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
//         heightLeft -= pdf.internal.pageSize.getHeight();
//       }

//       pdf.save(`Cellfunds-Invoice-${this.formFields.accountName}_${this.formFields.invoiceDate}.pdf`);
//     } catch (error) {
//       console.error('Error generating invoice PDF:', error);
//     } finally {
//       this.loading3 = false;
//     }
//   });
// },
async createInvoice() {
  this.loading3 = true;
  const data = this.getSampleData();
  console.log(data);
  console.log(this.inputs);

  for (let i = 0; i < this.inputs.length; i++) {
        data.products.push({
          quantity: this.inputs[i].quantity,
          make: this.inputs[i].make,
          model: this.inputs[i].model,
          amount: this.inputs[i].amount,
          description: this.inputs[i].make + 
          '   ' + this.inputs[i].model + 
          ' ' + this.inputs[i].IMEI + ' Hours : ' + this.inputs[i].serviceHours + '    |   Days from Week: ' + this.inputs[i].daysFromWeek + '   |   Daily Cost: ' + this.formFields.dailyCost + '   |   Weekly Cost:' + this.formFields.weeklyCost + '   |   Monthly Cost:' + this.formFields.monthlyCost + '   |   Yearly Cost:' + this.formFields.yearlyCost + '| Holiday Rate:' + this.inputs[i].holidayRate + '| Golf Cart Rate:' + this.inputs[i].golfCartRate + '| Standing Guard Rate:' + this.inputs[i].amount,
          'tax-rate': this.formFields.tax,
          price: this.inputs[i].Amount,
        });

  data.extraFields = {
    totalDaysPerMonth: this.formFields.totalDaysPerMonth,
    totalHoursPerMonth: this.formFields.totalHoursPerMonth,
    dailyCost: this.formFields.dailyCost,
    weeklyCost: this.formFields.weeklyCost,
    monthlyCost: this.formFields.monthlyCost,
    yearlyCost: this.formFields.yearlyCost,
    quantity: this.formFields.quantity,
    daysFromWeek: this.formFields.daysFromWeek,
    serviceHours: this.formFields.serviceHours,
  };
}

data.introduction = "Instaguard Security Services is a leading provider...";

// Begin PDF generation
const pdf = new jsPDF({
  orientation: 'p',
  unit: 'pt',
  format: 'letter'
});

let imgWidth = 8.5 * 72; // for letter size
let firstPageAdded = false;

for (let currentPage = 1; currentPage <= 6; currentPage++) {
  this.currentPage = currentPage;
  await this.$nextTick();

  const invoiceElement = document.getElementById('invoice-preview');
  if (!invoiceElement) {
    this.loading3 = false;
    return;
  }

  try {
    // Adjust scale and quality for better size control
    const canvas = await html2canvas(invoiceElement, {
      scale: 1,
      useCORS: true,
      logging: true,
      windowHeight: document.body.scrollHeight,
      windowWidth: document.body.scrollWidth
    });

    // Decide on the format based on a condition or preference
    const useJPEG = true; // Example condition; adjust as needed
    const imgFormat = useJPEG ? 'image/jpeg' : 'image/png';
    const quality = useJPEG ? 1 : 1; // Adjust JPEG quality as needed; PNG quality is ignored
    const imgData = canvas.toDataURL(imgFormat, quality);
    const imgHeight = canvas.height * imgWidth / canvas.width;

    if (firstPageAdded) {
      pdf.addPage();
    } else {
      firstPageAdded = true;
    }

    pdf.addImage(imgData, imgFormat === 'image/jpeg' ? 'JPEG' : 'PNG', 0, 0, imgWidth, imgHeight);
  } catch (error) {
    console.error('Error generating invoice PDF:', error);
    this.loading3 = false;
    return;
  }
}

let today = new Date();
let fileName = `Instaguard-Proposal-${data.client.company}-${today.toISOString().split('T')[0]}.pdf`;
pdf.save(fileName); // Triggers the download of the PDF
this.loading3 = false;
},

getSampleData() {
  this.loading3 = true;
  const template = `
<!DOCTYPE html>
<html>
<head>
  <title>Proposal</title>
  <style>
  @page {
    size: 8.5in 11in;
    margin: 0;
  }
  body {
    margin: 0;
  }
  .page {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    page-break-after: always;
  }
  .cover {
    width: 540px;
    height: 699px;
    margin-bottom: 0px;
    padding-top: 90px;
    left: 0px;
  }
  .footercover {
    width: 535px;
    height: 59px;
    top: 0px;
    left: 0;
  }
  .text {
    color: white;
    font-size: 12px;
    font-weight: bold;
    text-align: center;
    padding: 10px;
    font-family: Montserrat, sans-serif;
  }

  .text2 {
    color: white;
    font-size: 12px;
    font-weight: bold;
    text-align: center;
    padding: 10px;
    font-family: Lato, sans-serif;
  }
  table.blueTable {
  background-color: #EEEEEE;
  width: 100%;
  text-align: center;
  border-collapse: collapse;
  left: 240px;
  top: -160px;
}
table.blueTable td, table.blueTable th {
  padding: 3px 2px;
}
table.blueTable tbody td {
  font-size: 13px;
}
table.blueTable tr:nth-child(even) {
  background: #D0E4F5;
}
table.blueTable tfoot td {
  font-size: 14px;
}
table.blueTable tfoot .links {
  text-align: right;
}
table.blueTable tfoot .links a{
  display: inline-block;
  background: #1C6EA4;
  color: #FFFFFF;
  padding: 2px 8px;
  border-radius: 5px;
}
  .wrapper {
    margin: 0 auto;
    width: 540px;
    text-align: center;
  }
  .box {
    background-color: #3383c8;
    border-radius: 0px;
    width: 500px;
    height: 50px;
    margin: 8px;
    padding: 5px;
    color: black;
    font-size: 12px;
    font-weight: normal;
    text-align: center;
    font-family: Lato, sans-serif;
    margin-left: 19px;
  }
  .box3 {
    background-color: #3383c8;
    width: 520px;
    height: 10px;
    margin: 5px;
    padding: 10px;
  }
  .column {
    width: 138px;
    height: 50px;
    margin: 8px;
    padding: 8px;
    color: black;
    font-size: 14px;
    font-weight: bold;
    font-family: Lato, sans-serif;
    text-align: center;
    top: 4px;
    left: 0px;
    right: 0px;
    padding-top: 10px;
    align-content: center;
  }
  .after-box {
    clear: left;
  }
  .clearfix {
    overflow: auto;
  }
  .center {
    text-align: center;
  }
  .center div {
    text-align: left;
  }
  .inlineExample {
    display: inline-block;
  }
  #box1 {
    background-color: #3383c8;
    border-radius: 0px;
  }
  .artooScale {
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
  }
  .artooIndividual {
    background-size: 20%, cover;
    background-repeat: no-repeat, repeat;
    background-position: 0px 50px, top right;
    text-align: center;
  }
</style>

</head>
<body>
    <img src="https://instaguardinc.com/wp-content/uploads/assets/Picture5.jpg" class="cover" alt="Instaguard Logo" />
<div class="page">
  <pagebreak></pagebreak>
<div class="header">
  <p class="text">WELCOME TO INSTAGUARD SECURITY SERVICES</p>
</div>
<br />
<span style="font-size:18px;font-family: Lato, sans-serif;color:black;font-weight:bold;">%company-to%</span>
<p style="margin-top:0pt;margin-bottom:0pt;margin-left:0in;text-align:left;"><span style="font-size:18px;font-family: Lato, sans-serif;color:black;">%address-to%</span></p>
<p style="margin-top:0pt;margin-bottom:0pt;margin-left:0in;text-align:left;"><span style="font-size:18px;font-family: Lato, sans-serif;color:black;">%contact-to%</span></p>
<p style="margin-top:0pt;margin-bottom:0pt;margin-left:0in;text-align:left;"><span style="font-size:18px;font-family: Lato, sans-serif;color:black;">%city-to%, %zip-to% </span></p>
<br />
<p style="margin-top:0pt;margin-bottom:0pt;margin-left:0in;text-align:left;"><span style="font-size:18px;font-family: Lato, sans-serif;color:black;font-weight:bold;"><span style="font-size:18px;font-family: Lato, sans-serif;color:black;font-weight:bold;">%company-to%</span>,</span></p>
<br />
<p style="margin-top:0pt;margin-bottom:0pt;margin-left:0in;text-align:left;"><span style="font-size:18px;font-family: Lato, sans-serif;color:black;">We appreciate this opportunity to introduce our services in detail. Please review the following proposal we are submitting for the security protection services needed at&nbsp;</span><span style="font-size:18px;font-family: Lato, sans-serif;color:black;font-weight:bold;"> %address-to%, in %city-to%, %zip-to%</span><span style="font-size:18px;font-family: Lato, sans-serif;color:black;">.&nbsp;</span></p>
<br>
<p style="margin-top:0pt;margin-bottom:0pt;margin-left:0in;text-align:left;"><span style="font-size:18px;font-family: Lato, sans-serif;color:black;">Our reputation rests on the quality of the security services &amp; &nbsp;support we provide to our clients. We have grown into an industry leader &amp; succeeded by simply exceeding our customers&rsquo; expectations.&nbsp;</span></p>
<br>
<p style="margin-top:0pt;margin-bottom:0pt;margin-left:0in;text-align:left;"><span style="font-size:18px;font-family: Lato, sans-serif;color:black;">Instaguard</span><span style="font-size:18px;font-family: Lato, sans-serif;color:black;">&nbsp;works hard to provide the best security services in California. We treat all our clients and guards with respect, so there is a very good chance that our clients will to us for future security service needs.&nbsp;</span></p>
<br>
<p style="margin-top:0pt;margin-bottom:0pt;margin-left:0in;text-align:left;"><span style="font-size:18px;font-family: Lato, sans-serif;color:black;">Instaguard</span><span style="font-size:18px;font-family: Lato, sans-serif;color:black;">&nbsp;has been providing security protection since 2008. As a Southern California leader in security, we proudly serve all of California. Our corporate office in in Sherman Oaks, CA we a centrally located to support Los Angeles, Ventura Counties &amp; Orange Counties.</span></p>
<br>
<p style="margin-top:0pt;margin-bottom:0pt;margin-left:0in;text-align:left;"><span style="font-size:18px;font-family: Lato, sans-serif;color:#black;">We thank you for this opportunity to introduce our company and we look forward to earning your business. Any questions, please let our team know so we can be of help.</span></p>
<br>
<p style="margin-top:0pt;margin-bottom:0pt;margin-left:0in;text-align:left;"><span style="font-size:18px;font-family: Lato, sans-serif;sans-serif;color:#262626;">Thank you,</span></p>
<p style="margin-top:0pt;margin-bottom:0pt;margin-left:0in;text-align:left;"><span style='font-size:18px;font-family: Lato, sans-serif;color:#262626; font-weight: bold;'>Instaguard Team</span></p>
<br>
<div>
          <img :src="images.footer-welcome" alt="Cover">
  </div>

</div>
  <div class="page">
    <pagebreak></pagebreak>
  <div class="header">
  <p class="text">SCOPE OF SERVICES</p>
</div>
<products>
  <div class="vertWrapper">
      <div class="wrapper clearfix center">
        <div class="column inlineExample artooIndividual" id="box1" style="text-align: center;">OFFICERS <br> <div style="text-align: center;" class="text2"> %quantity%</div></div>
        <div class="column inlineExample artooIndividual" id="box1" style="text-align: center;">DAYS <br> <div style="text-align: center;" class="text2"> ${this.formFields.daysFromWeek}</div></div>
        <div class="column inlineExample artooIndividual" id="box1" style="text-align: center;">HOURS <br> <div style="text-align: center;" class="text2"> ${this.formFields.serviceHours}</div></div>
      </div>
    </div>

    
<div class="vertWrapper">
      <div class="wrapper clearfix center">
        <table class="box">
    <thead>
      <tr>
        <th class="text2">SERVICE LOCATION</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>%address-to%, %city-to%, %zip-to%</td>
      </tr>
    </tbody>
  </table>
        </div>
</div>



<br>
<p style="margin-top:0pt;margin-bottom:0pt;margin-left:0in;text-align:left;"><span style="font-size:18px;font-family:Lato, sans-serif;color:black;font-weight:bold;">Instaguard</span><span style="font-size:18px;font-family:Lato, sans-serif;color:black;font-weight:bold;">&nbsp;is to provide a uniformed, on-site, unarmed security officer(s) to patrol %company-to%.</span></p>
<br>
<div style="margin-top:0pt;margin-bottom:0pt;margin-left:.19in;text-indent:-.19in;text-align:left;"><span style="font-size:18px;"><span style="font-family:Lato, sans-serif;">&bull;</span></span><span style="font-size:18px;font-family:Lato, sans-serif;color:black;">A comprehensive set of Post Orders will be generated by the Instaguard staff to be approved by <span style="font-size:18px;font-family: Lato, sans-serif;color:black;font-weight:bold;">%company-to%</span></span></div>
<div style="margin-top:0pt;margin-bottom:0pt;margin-left:.19in;text-indent:-.19in;text-align:left;"><span style="font-size:18px;"><span style="font-family:Lato, sans-serif;">&bull;</span></span><span style="font-size:18px;font-family:Lato, sans-serif;color:black;">Any keys, pass codes, emergency contacts, etc. needed to perform the security functions will be provided by <span style="font-size:18px;font-family: Lato, sans-serif;color:black;font-weight:bold;">%company-to%</span> into the post orders.</span></div>
<div style="margin-top:0pt;margin-bottom:0pt;margin-left:.19in;text-indent:-.19in;text-align:left;"><span style="font-size:18px;"><span style="font-family:Lato, sans-serif;">&bull;</span></span><span style="font-size:18px;font-family:Lato, sans-serif;color:black;"><span style="font-size:18px;font-family: Lato, sans-serif;color:black;font-weight:bold;">%company-to%</span> will provide restroom facilities for the security officer and a place for the security officer to take his/her California mandated rest breaks. Please note, the security officer by law are required two (10) minute paid rest breaks. In addition, they will be afforded a thirty (30) minute paid on-duty meal break.</span></div>
<div style="margin-top:0pt;margin-bottom:0pt;margin-left:.19in;text-indent:-.19in;text-align:left;"><span style="font-size:18px;"><span style="font-family:Lato, sans-serif;">&bull;</span></span><span style="font-size:18px;font-family:Lato, sans-serif;color:black;">Assigned security consultant will address&nbsp;</span><span style="font-size:18px;font-family:Lato, sans-serif;color:black;">any and all</span><span style="font-size:18px;font-family:Lato, sans-serif;color:black;">&nbsp;future changes and concerns, information will be provided after commencement of services.</span></div>
<div style="margin-top:0pt;margin-bottom:0pt;margin-left:.19in;text-indent:-.19in;text-align:left;"><span style="font-size:18px;"><span style="font-family:Lato, sans-serif;">&bull;</span></span><span style="font-size:18px;font-family:Lato, sans-serif;color:black;">Instaguard</span><span style="font-size:18px;font-family:Lato, sans-serif;color:black;">&nbsp;will provide <span style="font-size:18px;font-family: Lato, sans-serif;color:black;font-weight:bold;">%company-to%</span> an introduction letter for its employees outlining our 24-hour dispatch numbers, on-site security officers, Regional Supervisor and all customer services access numbers.</span></div>
<div style="margin-top:0pt;margin-bottom:0pt;margin-left:.19in;text-indent:-.19in;text-align:left;"><span style="font-size:18px;"><span style="font-family:Lato, sans-serif;">&bull;</span></span><span style="font-size:18px;font-family:Lato, sans-serif;color:black;">Instaguard</span><span style="font-size:18px;font-family:Lato, sans-serif;color:black;">&nbsp;Services includes but are not limited to: Vehicle Patrol, Security Training Facilities, Security Alarm Response, Power to Arrest, Incident Reporting, Special Event Services, Electronic Security Solution, Security Assessments, and Active Shooting, Fire/Life Safety.&nbsp;</span><span style="font-size:18px;font-family:Lato, sans-serif;color:black;">Instaguard</span><span style="font-size:18px;font-family:Lato, sans-serif;color:black;">&nbsp;mandates all security personnel undergo intensive training in: Ethics, Sexual Harassment,&nbsp;</span><span style="font-size:18px;font-family:Lato, sans-serif;color:black;">Instaguard</span><span style="font-size:18px;font-family:Lato, sans-serif;color:black;">&nbsp;Aid, CPR, Risk Assessment, Predictive Profiling, De-Escalation prevention, and Interpersonal Skills.</span></div>
<div style="margin-top:0pt;margin-bottom:0pt;margin-left:.19in;text-indent:-.19in;text-align:left;"><span style="font-size:18px;"><span style="font-family:Lato, sans-serif;">&bull;</span></span><span style="font-size:18px;font-family:Lato, sans-serif;color:black;">Security Support shall commence on <span style="font-size:18px;font-family: Lato, sans-serif;color:black;font-weight:bold;">TBD</span> and shall continue until terminated upon 30&nbsp; days prior to written notice by either party.</span></div>
<br>
<br>
<div class="footer-container">
        <img :src="images.footer" class="footercover" alt="Footer">
</div>
</div>
  <div class="page">
    <pagebreak></pagebreak>
  <div class="header">
  <p class="text">SERVICE INVESTMENT</p>
</div>
<br>
<div class="vertWrapper">
      <div class="wrapper clearfix center">
        <table class="box">
  <tr>
    <th>TYPE OF SECURITY SERVICE</th>
    <th>${this.inputs.Model}</th>
  </tr>
  </table>

<br>
  <table class="blueTable" style="width: 500px; margin-left: 19px; margin-top: -15px;">
  <tr>
    <th>Hourly Rate</th>
    <th>%price%</th>
  </tr>
  <tr>
    <td>Signage around Property</td>
    <td>Included</td>
  </tr>
  <tr>
    <td>Body Cam</td>
    <td>Included</td>
  </tr>
  <tr>
    <td>Cell Phone</td>
    <td>Included</td>
  </tr>
  <tr>
    <td>Reporting System</td>
    <td>Included</td>
  </tr>
</table>
<br>
<br>
<p style="margin-top:0pt;margin-bottom:0pt;margin-left:0in;text-align:left;"><span style="font-size:18px;font-family: Lato, sans-serif;color:black;">Note: Overtime rates will apply to work in excess of 8-hours per day or 40-hours per week. Holidays rates only apply to work on New Year’s Day, Memorial Day, Independence Day, Labor Day, Thanksgiving and Christmas. Coverage for labor disputes or natural disaster is not included except as described in the Service Rates Classification.</span></p>
<br>
<p style="margin-top:0pt;margin-bottom:0pt;margin-left:0in;text-align:left;"><span style="font-size:18px;font-family: Lato, sans-serif;color:black;"></span><span style="font-size:18px;font-family: Lato, sans-serif;color:black;">Instaguard looks forward to offering our services to your company. Please let me know the start date for services and I’ll forward our agreement for your approval.</span></p>
<br>
<p style="margin-top:0pt;margin-bottom:0pt;margin-left:0in;text-align:left;"><span style="font-size:18px;font-family: Lato, sans-serif;color:black;">Regards,</span></p>
<br>
<p style="margin-top:0pt;margin-bottom:0pt;margin-left:0in;text-align:left;"><span style='font-size:18px;font-family: Lato, sans-serif;color:black;'></span><span style='font-size:12px;font-family: Lato, sans-serif;color:black;'>&nbsp;Instaguard Team</span></p>
<br>
<table style="font-size:14px; color:black; font-family: Lato, sans-serif; text-align: left;width: 500px">
  <tr>
    <th>Authorized Representative:</th>
    <th>_____________________________________</th>
  </tr>
  <tr>
    <th>Signature:</th>
    <th>_____________________________________</th>
  </tr>
  <tr>
    <th>Title:</th>
    <th>_____________________________________</th>
  </tr>
  <tr>
    <th>Date:</th>
    <th>_____________________________________</th>
  </tr>
</table>
<br>
<br>
<br>
<br>
<br>
<br>
<br>
<div class="footer-container">
        <img :src="images.footer" class="footercover" alt="Footer">
</div>
</div
  <div class="page">
    <pagebreak></pagebreak>
    <br>
<div class="header">
  <p class="text">SERVICE COST BREAKDOWN</p>
</div>
<br>

<div class="vertWrapper">
      <div class="wrapper clearfix center">

        <table style="font-family: Lato, sans-serif; width: 500px; margin-left: 0px;" class="box">
    <thead>
      <tr>
        <th>SECURITY SERVICE PROPOSAL</th>
      </tr>
    </thead>
  </table>
  <table class="blueTable" style="font-family: Lato, sans-serif; font-weight: light; width: 500px">
  <tr>
    <th>Date</th>
    <th>${this.formFields.proposalDate}</th>
  </tr>
  <tr>
    <th>Standing Guard Rate</th>
    <th>%price%</th>
  </tr>
  <tr>
    <th>Security Personnel</th>
    <th>%quantity%</th>
  </tr>
  <tr>
  <th>Hours of Service</th>
  <th>${this.formFields.serviceHours}</th>
</tr>
<tr>
  <th>Days</th>
  <th>${this.formFields.daysFromWeek}</th>
</tr>

</table>
<table
  style="font-family: Lato, sans-serif; width: 500px; margin-left: 0px;"
  class="box2"
>
<table style="font-family: Lato, sans-serif; width: 500px" class="box3">
  </table>
  <table class="blueTable" style="font-family: Lato, sans-serif; width: 500px; margin-left: 0px;">
    <tr>
      <th>Total Days Per Month</th>
      <th>${this.formFields.totalDaysPerMonth}</th>
    </tr>
    <tr>
      <th>Total Hours Per Month</th>
      <th>${this.formFields.totalHoursPerMonth}</th>
    </tr>
  </table>
  <table style="font-family: Lato, sans-serif; width: 500px; margin-left: 0px;" class="box3">
    <thead>
        <tr>
          <th>FINAL BREAKDOWN</th>
        </tr>
      </thead>
    </table>
    <table class="blueTable" style="font-family: Lato, sans-serif; font-weight: light; width: 500px">
    <tr>
      <th>Daily Cost</th>
      <th>$${this.formFields.dailyCost}</th>
    </tr>
    <tr>
      <th>Weekly Cost</th>
      <th>$${this.formFields.weeklyCost}</th>
    </tr>
    <tr>
      <th>Monthly Cost</th>
      <th>$${this.formFields.monthlyCost}</th>
    </tr>
    <tr>
      <th>Yearly Cost</th>
      <th>$${this.formFields.yearlyCost}</th>
    </tr>
  </table>
<br>
<br>
<br>
<br>
<br>
<br>
<br>
<br>
<br>
<br>
<br>
<br>
<div>
        <img :src="images.footer" class="footercover" alt="Footer">
</div>
</div>

<div class="page">
    <pagebreak></pagebreak>
<div class="header">
  <p class="text">TERMS & CONDITIONS</p>
</div>
<br>
<p style="margin-top:0pt;margin-bottom:0pt;margin-left:0in;text-align:left;"><span style="font-size:16px;font-family: Lato, sans-serif;color:black;">TERMS & CONDITIONS: Unless agreed otherwise by us in writing, these terms and conditions (Terms and Conditions) shall apply to the provision of all goods and/or Services provided by us to you. These Terms and Conditions are the Terms and Conditions referred to in any correspondence with you or referred to in the Temporary Security Services Form or any other form, quotation, proposal or confirmation of request for services. We reserve the right to amend the Terms and Conditions from time to time by written notice to you. Your continued use of the Services will be deemed acceptance of such amended Terms and Conditions and such amended Terms and Conditions will replace any previous arrangements or understandings between you and Instaguard Security. 
</span><span style="font-size:16px;font-family: Lato, sans-serif;color:black;"></span></p>
<br>

<p style="margin-top:0pt;margin-bottom:0pt;margin-left:0in;text-align:left;"><span style="font-size:16px;font-family: Lato, sans-serif;color:black;">ACCEPTANCE: If: (a) we accept a request for goods and/or Services from you; and/or (b) you complete a Temporary Security Services Form and we accept that form; and/or (c) you accept a quote for goods and/or Services to be provided by us, that shall constitute acceptance of these Terms and Conditions and such request, quote or Temporary Security Services Form (as applicable) together with these Terms and Conditions shall constitute the agreement between you and us (the Agreement). Any variations or additions to the Agreement not expressly agreed in writing by us are expressly rejected by us.
 
</span><span style="font-size:16px;font-family: Lato, sans-serif;color:black;"></span></p>
<br>
<p style="margin-top:0pt;margin-bottom:0pt;margin-left:0in;text-align:left;"><span style="font-size:16px;font-family: Lato, sans-serif;color:black;">SECURITY SERVICES: We will provide to you the goods and/or Services specified in the Temporary Security Services Form (or, where the Agreement arises by way of a quotation or confirmation of request for Services, such quotation or confirmation of request for Services) and such further ancillary Services requested by you from time to time (including any request for us to deploy security guards to your Premises at any unscheduled time), provided that: (a) no security guard may be requested to provide Services to you for anything less than a four hour unbroken period; (b) no security guard will be deployed to your Premises unless a start and end time for the deployment has been agreed; (c) once we have agreed to deploy a security guard to your Premises, that deployment may not be cancelled by you unless you provide us with notice in writing of the cancellation: (i) in the case of Casual Services, at least four hours prior to the commencement of the deployment (and if you provide less than four hours’ notice, you shall be charged for all the scheduled hours of the deployment notwithstanding that such deployment may no longer be required and/or not occur); and (ii) in the case of Permanent Services, at least 30 days’ prior to the commencement of the last deployment (and if you provide less than 30 days’ notice, you shall be charged for all the scheduled hours of the deployment notwithstanding that such deployment may no longer be required and/or not occur); (d) we shall determine, in our sole discretion, the manner and means by which the Services are performed.
</span></p>
<br>
<br>
<br>
  
<div class="footer-container">
        <img :src="images.footer" class="footercover" alt="Footer">
</div>

        </div>
</div>
</div>
</products>
</body>
</html>
  `;
  const base64Template = Base64.encode(template);
  return {
    customize: {
      template: base64Template
    },
    extraFields: [],
    introduction: 'Hello what is your name?',
    sender: {
      company: 'Instaguard Security Services',
      address: 'Your Company Address',
      city: 'Your City',
      state: 'Your State',
      zip: 'Your Zipcode',
      phonenumber: 'Your Phone Number',
      website: 'www.instaguard.com',
      phone: 'Your Phone Number',
    },
    client: {
      company: this.formFields.accountName,
      contact: this.formFields.contactName,
      address: this.formFields.street,
      city: this.formFields.city,
      state: this.formFields.state,
      zip: this.formFields.zipcode,
    },
    information: {
      date: this.formFields.proposalDate,
      number: this.formFields._id,
      hours: this.inputs.serviceHours,
      days: this.inputs.daysFromWeek,
      price: this.formFields.amount,
      amount: this.formFields.amount,
      model: this.inputs.Model,
      make: this.inputs.Make,
      quantity: this.formFields.quantity,
    },
    products: [],
    settings: {
          currency: 'USD', // See documentation 'Locales and Currency' for more info. Leave empty for no currency.
          "locale": "en-US", // Defaults to en-US, used for number formatting (see docs)
          // "taxNotation": "gst", // Defaults to vat
          // "margin-top": -200, // Default to 25
          // "margin-right": 25, // Default to 25
          // "margin-left": 25, // Default to 25
          // "margin-bottom": 25, // Default to 25
          // "text-align": "left", // Default to center
          // "format": "Letter", // Defaults to A4
          // "color": "blue", // Defaults to black
          // "bottom-notice": -150, // Defaults to 15 (measured in mm)
        },
        // Used for translating the headers to your preferred language
        // Defaults to English. Below example is translated to Dutch
        translate: {
          invoice: 'Proposal',
        },
      };
    },
},
};
</script>


<style scoped>
.page-counter {
  margin: 0 10px;
  font-weight: bold;
  color: #ffffff;
}
.first-box {
  outline: 2px solid #000; /* Change the color and size as needed */
  border-radius: 10px; /* Adjust the radius as you see fit */
  background-color: lightblue; /* This sets the light blue background */
  padding: 10px; /* Add some padding inside the box, optional */
  margin-bottom: 20px; /* Optional: Adds some space below the box */
  color: rgb(0, 0, 0);
  font-size: 14px;
  font-weight: bold;
  text-align: center;
  padding: 10px;
  font-family: Lato, sans-serif;
}
.box4 {
  background-color: #3383c8;
    border-radius: 0px;
    width: 85%;
    height: 90px;
    margin: 5px;
    padding-block: -10px;
    color: black;
    font-size: 16px;
    font-weight: normal;
    text-align: center;
    font-family: Lato, sans-serif;
    margin-left: 19px;
}
.cover {
  width: 100%;
    height: 100%;
    left: 0px;
  }
  .header {
    background: black;
    width: 100%;
    height: 100%;
    margin-left: 0px;  
  }
  .headercover {
    width: 100%;
    height: 100%;
    bottom: 50px;
    left: 0;
  }
.footer-container {
      position: relative;
      /* Ensure the container has a height or is influenced by its content */
      min-height: 100px; /* Example height */
      width: 100%; /* Adjust based on your layout */
    }

    .footercover {
      position: absolute;
      align-self: baseline; 
      width: 100%;
      max-height: 100%; /* Adjust if necessary */
      bottom: 0; /* Stick to the bottom */
      left: 0;
    }
  .text {
    color: white;
    font-size: 16px;
    font-weight: bold;
    text-align: center;
    padding: 10px;
    font-family: Montserrat, sans-serif;
  }

  .text2 {
    color: white;
    font-size: 14px;
    font-weight: bold;
    text-align: center;
    padding: 10px;
    font-family: Lato, sans-serif;
  }
  .text3 {
    color: black;
    font-size: 16px;
    font-weight: bold;
    text-align: center;
    padding: 10px;
    font-family: Lato, sans-serif;
  }
  .text4 {
    color: black;
    margin-top: 14px;
    font-size: 16px;
    font-weight: bold;
    text-align: center;
    font-family: Lato, sans-serif;
  }
  /* .text5 {
    color: black;
    font-size: 18px;
    font-weight: bold;
    margin-top: -30px;
    margin-left: 80px;
    padding: 0px;
    font-family: Lato, sans-serif;
  } */
  table.blueTable {
  background-color: #EEEEEE;
  width: 100%;
  text-align: center;
  border-collapse: collapse;
  left: 240px;
  top: -160px;
}
table.blueTable td, table.blueTable th {
  padding: 10px 10px 10px 10px;
}
table.blueTable tbody td {
  font-size: 16px;
  font-family: Lato, sans-serif;
}
table.blueTable tr:nth-child(even) {
  background: #D0E4F5;
}
table.blueTable tfoot td {
  font-size: 14px;
  font-family: Lato, sans-serif;
}
table.blueTable tfoot .links {
  text-align: right;
}
table.blueTable tfoot .links a{
  display: inline-block;
  background: #1C6EA4;
  color: #FFFFFF;
  padding: 2px 8px;
  border-radius: 5px;
}
  .wrapper {
    margin: 0 auto;
    width: 100%;
    text-align: center;
  }
  .outer {
  width: 1px;
  height: 100%;
  margin: auto;
  position: relative;
  overflow: hidden;
}
.inner {
  position: absolute;
  width:100%;
  height: 40%;
  background: grey;
  top: 30%;
  box-shadow: 0px 0px 30px 20px grey;
}
div.vertical-line {
 height: 45px;
 margin: 2px;
 padding-block: 8px;
 margin-left: -60px;
 margin-top: 3px;
 position: sticky;
}

div.vertical-line.left {
 border-left: 3px solid #162730;
}
.box {
  font-family: Lato, sans-serif;
  width: 93%;
  background-color: #3383c8;
  color: rgb(0, 0, 0);
  text-align: center;
  display: flex;
  justify-content: space-between;
  margin-left: 18.5px;  
  align-items: center;
  padding: 5px;
}

.title-column, .content-column {
  flex-basis: 32.5%; /* Each column takes up 30% of the width */
  text-align: center;
  padding: 10px;
}

.vertical-line-container {
  flex-basis: 5%; /* Adjusted to fit within the layout */
  display: flex;
  justify-content: center;
  align-items: center;
}

.vertical-line {
  height: 50px;
  border-left: 3px solid rgb(0, 0, 0);
}

.content-column {
  display: flex;
  justify-content: center;
  align-items: center;
}

.text5 {
  margin: 0;
  padding: 5px 15px 5px 10px;
  text-align: center;
  font-size: 18px;
}


  .box2 {
    background-color: #3383c8;
    border-radius: 0px;
    width: 98%;
    height: 80px;
    margin: 8px;
    padding-block: 8px;
    color: black;
    font-size: 16px;
    font-weight: normal;
    text-align: center;
    font-family: Lato, sans-serif;
    margin-left: 6px;
    margin-top: 20px;
  }
  .box3 {
    background-color: #3383c8;
    width: 520px;
    height: 10px;
    margin: 5px;
    padding: 10px;
  }
  
  .row-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.left-column, .right-column {
  flex: 1;
}

.left-column {
  text-align: left;
}

.right-column {
  text-align: right;
}

.account-name, .proposal-date {
  font-size: 15px;
  font-family: Lato, sans-serif;
  color: black;
  font-weight: bold;
}
  .column {
    width: 215px;
    height: 120px;
    margin: 4px;
    padding: 2px;
    color: black;
    font-size: 14px;
    font-weight: bold;
    font-family: Lato, sans-serif;
    text-align: center;
    top: 4px;
    left: 0px;
    right: 0px;
    padding-top: 10px;
    align-content: center;
  }
  .after-box {
    clear: left;
  }
  .clearfix {
    overflow: auto;
  }
  .center {
    text-align: center;
  }
  .center div {
    text-align: left;
  }
  .inlineExample {
    display: inline-block;
  }
  #box1 {
    background-color: #3383c8;
    border-radius: 0px;
  }
  .artooScale {
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
  }
  .artooIndividual {
    background-size: 33%, cover;
    background-repeat: no-repeat, repeat;
    background-position: 0px 50px, top right;
    text-align: center;
  }
.page {
  break-inside: avoid;
  margin-bottom: 20px;
}

.navigation-controls {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}
hr {
            position: relative;
            border: none;
            height: 1px;
            background: black;
        }
.first-place {
  background-color: rgb(105, 223, 105);
}
.second-place {
  background-color: rgb(32, 124, 158);
}
.third-place {
  background-color: rgba(32, 124, 158, 0.4);
}
.fourth-place {
  background-color: rgba(151, 151, 151, 0);
}
.fifth-place {
  background-color: rgba(32, 124, 158, 0.05);
}
.sixth-place {
  background-color: rgba(151, 151, 151, 0);
}
.seventh-place {
  background-color: rgba(32, 124, 158, 0.05);
}
.eighth-place {
  background-color: rgba(151, 151, 151, 0);
}
.ninth-place {
  background-color: rgba(32, 124, 158, 0.05);
}

.data-table-iframe {
margin-top: 530px;
height: 50px;
width: 100%; /* adjust according to your needs */
}

.data-table-iframe.show-data-table {
height: 600px; /* Adjust this value according to the size needed for the data table */
width: 100%; /* adjust according to your needs */
}

.default-size {
  height: 50px;
  width: 100%; /* adjust according to your needs */
}
.slide-fade-enter-active {
transition: all 0.3s ease;
}
.slide-fade-leave-active {
transition: all 0.8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
transform: translateX(-10px);
opacity: 0;
}
.report-frame {
width: 100%;
height: 300px;
border: 1px solid #ccc;
}
.invpreview {
  /* Existing styles remain unchanged */
  width: 8.5in; /* 8.5 inches wide */
  height: 11in; /* 11 inches tall */
  padding: 0.6in; /* Add padding to avoid content touching the edges */
  box-sizing: border-box; /* Include padding in the element's total width and height */
  background-color: #c3bfbf; /* Light grey background for on-screen readability */
  font-family: 'Helvetica', 'Arial', sans-serif; /* Use a clean, readable font */
  color: #333; /* Dark grey color for text to ensure good contrast for readability */
  display: flex;
  flex-direction: column; /* Stack children vertically */
  justify-content: start; /* Align content to start of the page */
  align-items: left; /* Center content horizontally */
  margin: 0 auto; /* Center the invoice preview in the window */
  -webkit-print-color-adjust: exact;
  color-adjust: exact;
}

@media print {
  .invpreview {
    background-color: #fff; /* Change background to white for printing */
    color: #000; /* Ensure text is black for maximum contrast */
    width: auto; /* Reset width for printing */
    height: auto; /* Reset height for printing */
    padding-block: 0.3in; /* Adjust padding for print */
    box-shadow: none; /* Remove shadows for print */
    page-break-after: always; /* Ensure a page break after the .invpreview element */
  }

  .invpreview:last-child {
    page-break-after: always; /* Avoid a page break after the last .invpreview element */
  }
}

.bg-content {
  background: #131f25e7;
  padding: 0px;
  min-height: 140vh;
  -webkit-animation: gradient 25s ease infinite;
  -animation: gradient 25s ease infinite;
}
  @-webkit-keyframes gradient {
    0% {
      background-position: 0% 50%;
    }
    50% {
      background-position: 100% 50%;
    }
    100% {
      background-position: 0% 50%;
    }
  }

  @keyframes gradient {
    0% {
      background-position: 0% 50%;
    }
    50% {
      background-position: 100% 50%;
    }
    100% {
      background-position: 0% 50%;
    }
    height: 150%;
  }
  
  @media only screen and (max-width: 600px) {
   .bg-content {
    background: #131f25e7;
  padding: 0px;
  min-height: 100vh;
  -webkit-animation: gradient 25s ease infinite;
  -animation: gradient 25s ease infinite;
}
  @-webkit-keyframes gradient {
    0% {
      background-position: 0% 50%;
    }
    50% {
      background-position: 100% 50%;
    }
    100% {
      background-position: 0% 50%;
    }
  }

  @keyframes gradient {
    0% {
      background-position: 0% 50%;
    }
    50% {
      background-position: 100% 50%;
    }
    100% {
      background-position: 0% 50%;
    }
    height: 150%;
  } 
}
.avatar-name {
position: relative;
top: 10px;
font-weight: 600;
margin-left: 8px;
margin-right: 5px;
}
.user-speach {
position: center;
font-size: 12px;
min-width: 0%;
max-width: 120%;
bottom: 15px;
height: 75px;
float: inherit;
left: -25px;
border-radius: 20px;
padding: 15px;
color: #fff;
/* transform: translate(-0%, -50%); */
}

@-webkit-keyframes gradient {
0% {
  background-position: 0% 50%;
}
50% {
  background-position: 100% 50%;
}
100% {
  background-position: 0% 50%;
}
}

@keyframes gradient {
0% {
  background-position: 0% 50%;
}
50% {
  background-position: 100% 50%;
}
100% {
  background-position: 0% 50%;
}
}

@media (min-width: 600px) {
.user-speach {
  position: absolute;
  font-size: 15px;
  min-width: 0%;
  max-width: 120%;
  bottom: 30px;
  height: 75px;
  float: inherit;
  left: 0.5%;
  border-radius: 20px;
  padding: 10px;
  color: #fff;
  /* transform: translate(-0%, -50%); */
}

@-webkit-keyframes gradient {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

@keyframes gradient {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}
}

.btn-text {
cursor: pointer;
display: inline-block;
font-size: 8px;
font-weight: 100;
line-height: 1.42857;
margin-bottom: 0;
padding: 3px 3px;
text-align: center;
vertical-align: middle;
}
@media (min-width: 600px) {
.btn-text {
  cursor: pointer;
  display: inline-block;
  font-size: 11px;
  font-weight: 300;
  line-height: 1.42857;
  margin-bottom: 0;
  padding: 6px 6px;
  text-align: center;
  vertical-align: middle;
}
}
.about {
padding: 0px;
width: 100%;
}
.db-content {
background: #304057;
background-size: 400% 400%;
padding: 40px;
min-height: 88vh;
-webkit-animation: gradient 25s ease infinite;
-animation: gradient 25s ease infinite;
}
.btn-right {
display: flex;
justify-content: flex-end;
flex-direction: row;
}
.mg-lr14 {
margin: 0px 14px;
}
.scroll {
overflow-y: scroll;
height: 100%;
}
.theme-bg-card {
background: rgba(48, 64, 87, 0.8);
outline-color: #42da91;
color: #fff;
border: 1px solid transparent;
box-shadow: 0 2px 4px rgba(0, 0, 0, 0.5), 0 6px 6px rgba(0, 0, 0, 0.3);
height: 400px;
}
.theme-bg-card:hover {
background: rgba(48, 64, 87, 0.8);
outline-color: #42da91;
outline-style: solid;
animation: glow 1800ms ease-out infinite alternate;
border-color: #42da91;
box-shadow: 0 0 10px rgba(90, 128, 191, 0.2),
  inset 0 0 10px rgba(90, 128, 191, 0.1), 0 0px 0 #000;
color: #efe;
outline: 20px;
}
.theme-bg-card-2 {
background: rgba(12, 22, 27, 0.10);
outline-color: #5a80bf;
color: rgb(255, 255, 255);
padding-block: 0px; 
top: 0px
}
@media only screen and (max-width: 600px) {
.theme-bg-card-2 {
  background: rgba(12, 22, 27, 0.10);
  outline-color: #5a80bf;
  color: rgb(255, 255, 255);
  padding: 10px; 
  top:0px
}
}
.theme-bg-card-proposal {
background: rgb(84, 89, 94);
outline-color: #42da91;
color: #fff;
border: 1px solid transparent;
box-shadow: 0 1px 2px rgba(0, 0, 0, 0.4), 0 3px 3px rgba(0, 0, 0, 0.3); 
height: 68vh;
top: -7rem;
}

.theme-bg-card-proposal:hover {
outline-color: #42da91;
outline-style: solid;
animation: glow 1800ms ease-out infinite alternate;
border-color: #42da91;
box-shadow: 0 0 10px rgba(90, 128, 191, 0.2),
  inset 0 0 10px rgba(90, 128, 191, 0.1), 0 0px 0 #000;
color: #efe;
outline: 20px;
}
.theme-bg-card-4 {
background: rgba(48, 64, 87, 0.85);
outline-color: #42da91;
color: #fff;
border: 1px solid transparent;
box-shadow: 0 2px 4px rgba(0, 0, 0, 0.5), 0 6px 6px rgba(0, 0, 0, 0.3);
height: 10vh;
border-radius: 30px;
}

.theme-bg-card-6 {
background: rgba(12, 22, 27, 0.4);
outline-color: #5a80bf;
color: #fff;
}
.chart-text {
color: #fff;
text-align: center;
font-size: 2.5rem;
font-weight: bold;
font-family: 'Courier New', Courier, monospace;
}
.tile-title {
color: #fff;
text-align: center;
font-size: 1.3rem;
font-weight: normal;
font-family: Arimo, sans-serif;
}
.chart-title {
color: #41e66d;
text-align: center;
font-size: 1.1rem;
font-weight: normal;
font-family: Arimo, sans-serif;
}
@media only screen and (max-width: 600px) {
.chart-title {
  color: #41e66d;
  text-align: center;
  font-size: 0.9rem;
  font-weight: normal;
  font-family: Arimo, sans-serif;
}
}


.theme-bg-card-5 {
background: rgba(48, 64, 87, 0.0);
border-radius: 25px;
width: 35%;

}


@media only screen and (max-width: 600px) {
.theme-bg-card-5 {
background: rgba(48, 64, 87, 0.6);

width: 50%;
}
}
.field {
margin-bottom: 30px;
padding: 30px;
border-radius: 20px;
  border-color: rgb(36, 212, 65);
border-radius: 20px;
padding-block: 20px;
margin-block: 5px;
border: 1px solid transparent;

}

.field label {
display: block;
font-size: 16px;
color: rgb(255, 255, 255);
}

.field input {
display: block;
min-width: 500px;
line-height: 2.5;
font-size: 16px;
color: rgb(36, 212, 65);
border-radius: 20px;
padding-block: 10px;
margin-block: 5px;
border: 1px solid transparent;
}

input[type="submit"] {
display: block;
padding: 10px 40px;
font-size: 14px;
background-color: rgb(36, 212, 65);
color: #fff;
border: none;
background: rgb(36, 212, 65, 0.4);
outline-color: #42da91;
color: #fff;
border: 1px solid transparent;
height: 50px;
}


.chart-title-2 {
text-align: center;
font-size: 1.3rem;
font-weight: 500;
color: #42da91;
font-family: Arial, Helvetica, sans-serif;
padding: 20px;
}
@media only screen and (max-width: 600px) {
.chart-title-2 {
  text-align: center;
  font-size: 12px;
  font-weight: 500;
  color: #42da91;
  font-family: Arial, Helvetica, sans-serif;
  padding: 5px;
}
}
.theme-bg-card-7 {
background: rgba(12, 22, 27, 0.0);
outline-color: #5a80bf;
color: rgb(255, 255, 255);
padding: 10px;
margin-left: -10px; 
top: 20px
}
@media only screen and (max-width: 600px) {
.theme-bg-card-7 {
  background: rgba(12, 22, 27, 0.0);
  outline-color: #5a80bf;
  color: rgb(255, 255, 255);
  padding: 10px; 
  top:0px
}
}

.chart-text {
color: #fff;
text-align: center;
font-size: 2.5rem;
font-weight: bold;
font-family: 'Courier New', Courier, monospace;
}

.tile-title {
color: #fff;
text-align: center;
font-size: 1.3rem;
font-weight: normal;
font-family: Arimo, sans-serif;
}
.chart-title {
color: #41e66d;
text-align: center;
font-size: 1.1rem;
font-weight: normal;
font-family: Arimo, sans-serif;
}
@media only screen and (max-width: 600px) {
.chart-title {
  color: #41e66d;
  text-align: center;
  font-size: 0.9rem;
  font-weight: normal;
  font-family: Arimo, sans-serif;
}
}
.chart-title-2 {
  color: #fff;
  text-align: center;
  font-size: 1rem;
  font-weight: thin;
  font-family: Arimo, sans-serif;
}


.theme-bg-card-5 {
background: rgba(48, 64, 87, 0.0);
border-radius: 25px;
width: 35%;

}


@media only screen and (max-width: 600px) {
.theme-bg-card-5 {
background: rgba(48, 64, 87, 0.6);

width: 50%;
}
}
.field {
margin-bottom: 30px;
padding: 30px;
border-radius: 20px;
  border-color: rgb(36, 212, 65);
border-radius: 20px;
padding-block: 20px;
margin-block: 5px;
border: 1px solid transparent;

}

.field label {
display: block;
font-size: 16px;
color: rgb(255, 255, 255);
}

.field input {
display: block;
min-width: 500px;
line-height: 2.5;
font-size: 16px;
color: rgb(36, 212, 65);
border-radius: 20px;
padding-block: 10px;
margin-block: 5px;
border: 1px solid transparent;
}

input[type="submit"] {
display: block;
padding: 10px 40px;
font-size: 14px;
background-color: rgb(36, 212, 65);
color: #fff;
border: none;
background: rgb(36, 212, 65, 0.4);
outline-color: #42da91;
color: #fff;
border: 1px solid transparent;
height: 50px;
}


.field {
margin-bottom: 30px;
padding: 30px;
border-radius: 20px;

}

.field label {
display: block;
font-size: 16px;
color: rgb(255, 255, 255);
}

.field input {
display: block;
min-width: 500px;
line-height: 2.5;
font-size: 16px;
color: rgb(0, 0, 0);
border-radius: 20px;
padding-block: 20px;
margin-block: 5px;
border: 1px solid transparent;
}

input[type="submit"] {
display: block;
padding: 10px 40px;
font-size: 14px;
background-color: #4460AA;
color: #000000;
border: none;
background: rgba(48, 64, 87, 0.8);
outline-color: #42da91;
border: 1px solid transparent;
height: 50px;
}
/* 
.button {
border-radius: 30px;
padding: 8px;
width: 3px;
border: outline;
background: #304057;
opacity: 0.9;
cursor: pointer;
margin-left: auto;
margin-right: auto;
align: center;
outline-color: #5a80bf;
outline-style: solid;
animation: glow 1800ms ease-out infinite alternate;
border-color: #5a80bf;
box-shadow: 0 0 5px rgba(90, 128, 191, 0.2),
  inset 0 0 3px rgba(90, 128, 191, 0.1), 0 2px 0 #000;
outline: none;
}
@keyframes glow {
  0% {
    border-color: #11ece5;
    box-shadow: 0 0 5px rgba(90, 128, 191, 0.2),
      inset 0 0 6px rgba(90, 128, 191, 0.4), 0 2px 0 #000;
  }
  100% {
    border-color: #11ece5;
    box-shadow: 0 0 8px rgba(90, 128, 191, 0.8),
      inset 0 0 10px rgba(90, 128, 191, 0.8), 0 2px 0 #000;
  }
}
@media only screen and (max-width: 600px) {

.button {
border-radius: 40px;
padding: 5px;
width: 5px;
border: outline;
background: #304057;
opacity: 0.9;
cursor: pointer;
margin-left: auto;
margin-right: auto;
align: center;
outline-color: #5a80bf;
outline-style: solid;
animation: glow 1800ms ease-out infinite alternate;
border-color: #5a80bf;
box-shadow: 0 0 5px rgba(90, 128, 191, 0.2),
  inset 0 0 3px rgba(90, 128, 191, 0.1), 0 2px 0 #000;
outline: none;
}
@keyframes glow {
  0% {
    border-color: #11ece5;
    box-shadow: 0 0 5px rgba(90, 128, 191, 0.2),
      inset 0 0 6px rgba(90, 128, 191, 0.4), 0 2px 0 #000;
  }
  100% {
    border-color: #11ece5;
    box-shadow: 0 0 8px rgba(90, 128, 191, 0.8),
      inset 0 0 10px rgba(90, 128, 191, 0.8), 0 2px 0 #000;
  }
}
} */

.button2  {
border-radius: 30px;
padding:  0px;
border: outline;
background: #304057;
opacity: 0.9;
cursor: pointer;
margin-left: auto;
margin-right: auto;
outline-color: #5a80bf;
outline-style: solid;
animation: glow 1800ms ease-out infinite alternate;
border-color: #5a80bf;
box-shadow: 0 0 5px rgba(90, 128, 191, 0.2),
  inset 0 0 3px rgba(90, 128, 191, 0.1), 0 2px 0 #000;
outline: none;
}
@keyframes glow {
  0% {
    border-color: #11ece5;
    box-shadow: 0 0 5px rgba(90, 128, 191, 0.2),
      inset 0 0 6px rgba(90, 128, 191, 0.4), 0 2px 0 #000;
  }
  100% {
    border-color: #11ece5;
    box-shadow: 0 0 8px rgba(90, 128, 191, 0.8),
      inset 0 0 10px rgba(90, 128, 191, 0.8), 0 2px 0 #000;
  }
}

.chart-content {
opacity: 0.7;
text-align: center;
margin-left: 0%;
top: -75px;
background: rgba(12, 22, 27, 0.4);
outline-color: rgba(90, 128, 191, 0.5);
outline-style: solid;
animation: glow 1800ms ease-out infinite alternate;
border-color: #5a80bf;
box-shadow: 0 0 5px rgba(120, 204, 226, 0.4), inset 0 0 10px rgba(120, 204, 226, 0.2), 0 4px 0 #000;
color: #efe;
outline-width: 2px;
padding: 15px;
border-radius: 10px;
margin: 10px;
}

@-webkit-keyframes gradient {
0% {
  background-position: 0% 50%;
}
50% {
  background-position: 100% 50%;
}
100% {
  background-position: 0% 50%;
}
}

@keyframes gradient {
0% {
  background-position: 0% 50%;
}
50% {
  background-position: 100% 50%;
}
100% {
  background-position: 0% 50%;
}
height: 150%;
}


.thrash {
font-size: 20px;
cursor: pointer;
}
.theme-bg-card-3 {
background: rgba(48, 64, 87, 0.5);
outline-color: #42da91;
color: #fff;
border: 1px solid transparent;
box-shadow: 0 2px 4px rgba(0, 0, 0, 0.5), 0 6px 6px rgba(0, 0, 0, 0.3);
height: 68vh;
top: -7rem;
}

.card-animate-2 {
animation-name: slideExpandUp;
/* position: relative;
position-fromtop: 100px; */
animation-duration: 3s;
transition: opacity 1s Elastic.easeIn;
}

.slideExpandUp {
animation-name: slideExpandUp;
-webkit-animation-name: slideExpandUp;

animation-duration: 2.7s;
-webkit-animation-duration: 2.7s;

animation-timing-function: ease-out;
-webkit-animation-timing-function: ease -out;

visibility: visible !important;
}

@keyframes slideExpandUp {
0% {
  -webkit-transform: translateY(10%) scaleX(0.94);
}
30% {
  -webkit-transform: translateY(-5%) scaleX(0.95);
}
40% {
  -webkit-transform: translateY(3%) scaleX(0.96);
}
50% {
  -webkit-transform: translateY(0%) scaleX(1);
}
}

@-webkit-keyframes slideExpandUp {
0% {
  -webkit-transform: translateY(10%) scaleX(0.94);
}
30% {
  -webkit-transform: translateY(-5%) scaleX(0.95);
}
40% {
  -webkit-transform: translateY(3%) scaleX(0.96);
}
50% {
  -webkit-transform: translateY(0%) scaleX(1);
}
}

.card-animate {
animation-name: slideExpandDown;
/* position: relative;
position-fromtop: 100px; */
animation-duration: 3s;
transition: opacity 1s Elastic.easeIn;
}
.slideExpandDown {
animation-name: slideExpandDown;
-webkit-animation-name: slideExpandDown;
animation-duration: 2.7s;
-webkit-animation-duration: 2.7s;
animation-timing-function: ease-out;
-webkit-animation-timing-function: ease -out;
visibility: visible !important;
}
@keyframes slideExpandDown {
0% {
  transform: translateY(100%) scaleX(0.94);
}
30% {
  transform: translateY(-4%) scaleX(0.95);
}
40% {
  transform: translateY(2%) scaleX(0.96);
}
50% {
  transform: translateY(0%) scaleX(1);
}
}
@-webkit-keyframes slideExpandDown {
0% {
  -webkit-transform: translateY(100%) scaleX(0.94);
}
30% {
  -webkit-transform: translateY(-4%) scaleX(0.95);
}
40% {
  -webkit-transform: translateY(2%) scaleX(0.96);
}
50% {
  -webkit-transform: translateY(0%) scaleX(1);
}
}
.popup-container {
margin-top: 40px;
height: 85vh;
width: 95vw;
background: rgba(48, 64, 87, 0.6);
padding: 20px 20px 20px 20px;
}
.font-weight-thin {
margin-top: 2rem;
margin-bottom: 2rem;
font-weight: 600;
}
.d-flex-row {
display: flex;
flex-direction: row;
}
.d-flex-col {
display: flex;
flex-direction: column;
}
.date-picker {
flex: 1 1 0%;
padding: 17px;
border: 1px solid #fff;
height: 53px;
width: auto;
color: #fff;
margin: 0 14px;
border-radius: 5px;
}
.form-control {
border: 1px solid #5e6570;
padding: 20px 20px;
margin-block: 3px 5px;
border-radius: 5px;
font-size: 14px;
background: transparent;
color: rgb(36, 212, 65);
}
@media only screen and (max-width: 600px) {
.form-control {
border: 1px solid #5e6570;
padding: 20px 20px;
margin-block: 3px 5px;
border-radius: 10px;
font-size: 12px;
background: transparent;
color: rgb(36, 212, 65);
}
}
.form-control-2 {
border: 1px solid #5e6570;
padding: 30px 30px 30px 30px;
margin-block: 3px 5px;
border-radius: 5px;
font-size: 14px;
width: 100%;
background: transparent;
color: rgb(255, 255, 255);

}
@media only screen and (max-width: 600px) {
.form-control-2 {
border: 1px solid #5e6570;
padding: 20px 20px;
margin-block: 3px 5px;
border-radius: 10px;
font-size: 12px;
width: 450px;
background: transparent;
color: rgb(36, 212, 65);
}
}
.form-control-3 {
display: block;
min-width: 480px;
line-height: 2.5;
font-size: 18px;
color: rgb(36, 212, 65);
border-radius: 20px;
padding-block: 20px;
margin-block: 5px;
border: 1px solid transparent;
}
@media only screen and (max-width: 600px) {
.form-control-3 {
display: block;
min-width: 480px;
line-height: 2.5;
font-size: 16px;
color: rgb(36, 212, 65);
border-radius: 20px;
padding-block: 20px;
margin-block: 5px;
border: 1px solid transparent;
}
}
.space2 {
height: 50px;
}
.action-btn {
font-size: 20px;
cursor: pointer;
position: relative;
top: 5px;
}
.typing {
padding: 15px;
/* background: rgba(37, 50, 68, 0.6);
  border-radius: 15px; */
border-radius: 20px;
min-width: 0%;
margin-left: 0px;
font-family: Arimo, sans-serif;
font-weight: normal;
font-size: 1.26em;
background: rgba(37, 50, 68, 0.2);
-webkit-animation: titleAnimation 20s infinite ease;
-animation: titleAnimation 100s normal forwards ease-in-out;
}

@keyframes titleAnimation {
0% {
  transform: translateY(-48px);
  opacity: 0;
  -webkit-clip-path: polygon(100% 0, 100% 100%, 0 100%, 0 80%);
  clip-path: polygon(100% 0, 100% 100%, 0 100%, 0 80%);
}
20% {
  transform: translateY(0);
  opacity: 1;
  -webkit-clip-path: polygon(100% 0, 100% 100%, 0 100%, 0 0%);
  clip-path: polygon(100% 0, 100% 100%, 0 100%, 0 0%);
}
80% {
  transform: translateY(0);
  opacity: 1;
  -webkit-clip-path: polygon(100% 0, 100% 100%, 0 100%, 0 0%);
  clip-path: polygon(100% 0, 100% 100%, 0 100%, 0 0%);
}
100% {
  transform: translateY(50px);
  opacity: 0;
  -webkit-clip-path: polygon(100% 0, 100% -0%, 0 100%, 0 100%);
  clip-path: polygon(100% 0, 100% -0%, 0 100%, 0 100%);
}
}
.typing2 {
padding: 15px;
/* background: rgba(37, 50, 68, 0.6);
  border-radius: 15px; */
border-radius: 20px;
min-width: 0%;
margin-left: 60px;
font-family: Arimo, sans-serif;
font-weight: normal;
font-size: 1.26em;
background: rgba(37, 50, 68, );

}

.product-list {
position: absolute;
margin-left: 160px;
margin-top: 38px;
width: 50%;
padding: 0px;
list-style: none;
background: rgba(48, 64, 87, 0.3);
color: rgb(255, 255, 255);
line-height: 2;
max-height: 200px;
overflow: auto;
border: 1px solid #7c7c7c;
border-radius: 8px;
}
.item {
padding: 10px;
border-bottom: 1px solid #ccc;
cursor: pointer;
}
.item:hover {
background: rgba(48, 64, 87, 0.8);
}
.calc {
width: 200px;
margin-bottom: 20px;
}
.loader {
border: 3px solid #f3f3f3;
border-radius: 50%;
border-top: 3px solid #3498db;
width: 15px;
height: 15px;
-webkit-animation: spin 2s linear infinite; /* Safari */
animation: spin 2s linear infinite;
position: relative;
margin-top: 12px;
margin-left: -15px;
}
/* Safari */
@-webkit-keyframes spin {
0% {
  -webkit-transform: rotate(0deg);
}
100% {
  -webkit-transform: rotate(360deg);
}
}
@keyframes spin {
0% {
  transform: rotate(0deg);
}
100% {
  transform: rotate(360deg);
}
}
</style>


<style lang="scss">
$base-duration: 500ms;

// Colors
$color-1: rgba(48, 64, 87, 0.85);
$color-2: rgba(48, 64, 87, 0.2);
$color-3: #2ecc71;

// Breakpoints
$sm: new-breakpoint(min-width 320px);
$med: new-breakpoint(min-width 768px);
$lg: new-breakpoint(min-width 1024px);

*, *:before, *:after {
box-sizing: border-box;
outline: none;
}

.hide { display: none;
}

.button {
position: relative;
display: flex;
flex-direction: column;
align-items: center;
justify-content: center;
width: 100%;
margin: 0px;  
border: none;
border-radius: 25px; 
transition: $base-duration ease;
overflow: hidden; 

&:before {
  position: absolute;
  content: '';
  bottom: 0;
  left: 0;
  width: 0%;
  height: 100%;
  background-color: lighten($color-3,10%);
}

span {
  position: absolute;
  line-height: 0;
  
  i {
    transform-origin: center center;
  }

  &:nth-of-type(1) {
    top: 50%;
    transform: translateY(-50%);
  }
  
  &:nth-of-type(2) {
    top: 100%;
    transform: translateY(0%);
    font-size: 24px;
  }
  
  &:nth-of-type(3) {
    display: none;
  }
}
}

.active {
background-color: $color-3;

&:before {
  width: 100%;
  transition: width 3s linear;
}

span {
  
  &:nth-of-type(1) {
    top: -100%;
    transform: translateY(-50%); 
  }

  &:nth-of-type(2) {
    top: 50%;
    transform: translateY(-50%);

    i {
      animation: loading $base-duration linear infinite;
    }
  }
  
  &:nth-of-type(3) {
    display: none;
  }
}
}

.finished {
background-color: lighten($color-3,10%);

.submit {
  display: none; 
}

.loading {
  display: none;
}

.check {
  display: block !important;
  font-size: 24px;
  animation: scale 0.5s linear;
  
  i {
    transform-origin: center center;
  }
}

}

@keyframes loading {
100% { transform: rotate(360deg); }
}

@keyframes scale {
0%   { transform: scale(10); }
50%  { transform: scale(0.2); }
70%  { transform: scale(1.2); }
90%  { transform: scale(0.7); }
100% { transform: scale(1); }
}

@media only screen and (max-width: 600px) {
 .button {
position: absolute;
width: 120px;
height: 250px;
margin: 0px;  
padding: 0.5rem 0.5rem;
background-color: $color-2;
border: none;
border-radius: 25px;
top: -270px; 
left: 5px;

// box-shadow:
// 	0 -1.25rem 1rem -1.5rem rgba(black, 0.4),
// 	0 0.5rem 1.75rem -0.25rem rgba(black, 0.3),
// 	0 1.25rem 2.5rem rgba(black, 0.2);
font-weight: 300;
text-transform: uppercase;
transition: $base-duration ease;
overflow: hidden; 

&:before {
  position: absolute;
  content: '';
  bottom: 0;
  left: 0;
  width: 0%;
  height: 100%;
  background-color: lighten($color-3,10%);
}

span {
  position: absolute;
  line-height: 0;
  
  i {
    transform-origin: center center;
  }

  &:nth-of-type(1) {
    top: 50%;
    transform: translateY(-50%);
  }
  
  &:nth-of-type(2) {
    top: 100%;
    transform: translateY(0%);
    font-size: 24px;
  }
  
  &:nth-of-type(3) {
    display: none;
  }
}
}

.active {
background-color: $color-3;

&:before {
  width: 100%;
  transition: width 3s linear;
}

span {
  
  &:nth-of-type(1) {
    top: -100%;
    transform: translateY(-50%); 
  }

  &:nth-of-type(2) {
    top: 50%;
    transform: translateY(-50%);

    i {
      animation: loading $base-duration linear infinite;
    }
  }
  
  &:nth-of-type(3) {
    display: none;
  }
}
}

.finished {
background-color: lighten($color-3,10%);

.submit {
  display: none; 
}

.loading {
  display: none;
}

.check {
  display: block !important;
  font-size: 24px;
  animation: scale 0.5s linear;
  
  i {
    transform-origin: center center;
  }
}

}

@keyframes loading {
100% { transform: rotate(360deg); }
}

@keyframes scale {
0%   { transform: scale(10); }
50%  { transform: scale(0.2); }
70%  { transform: scale(1.2); }
90%  { transform: scale(0.7); }
100% { transform: scale(1); }
}
}
</style>